(() => {
  "use strict";
  const carouselSound =
    window.NexCarouselSound ||
    (() => {
      const storageKey = "nex:carousel-sound",
        read = () => {
          try {
            const stored = window.sessionStorage.getItem(storageKey);
            return stored === "on" ? !0 : stored === "off" ? !1 : null;
          } catch {
            return null;
          }
        };
      let soundOn = read() ?? !1;
      const syncPair = (video, button) => {
          video &&
            ((video.muted = !soundOn),
            button &&
              (button.toggleAttribute("data-sound", soundOn),
              button.setAttribute("aria-pressed", String(soundOn)),
              button.setAttribute(
                "aria-label",
                soundOn
                  ? button.dataset.labelOff || "Turn sound off"
                  : button.dataset.labelOn || "Turn sound on",
              )));
        },
        sync = () => {
          (document.querySelectorAll("[data-hl-video]").forEach((video) => {
            const button = video.parentElement
              ? video.parentElement.querySelector("[data-hl-video-sound]")
              : null;
            syncPair(video, button);
          }),
            document.querySelectorAll("[data-wild-card]").forEach((card) => {
              syncPair(
                card.querySelector("video"),
                card.querySelector("[data-wild-sound]"),
              );
            }),
            document.querySelectorAll("[data-lp-card]").forEach((card) => {
              syncPair(
                card.querySelector("[data-lp-card-video]"),
                card.querySelector("[data-lp-card-sound]"),
              );
            }));
        },
        qualifyingVideos = () => {
          const videos = new Set(document.querySelectorAll("[data-hl-video]"));
          return (
            document.querySelectorAll("[data-wild-card]").forEach((card) => {
              const video = card.querySelector("video");
              video && videos.add(video);
            }),
            document
              .querySelectorAll("[data-lp-card-video]")
              .forEach((video) => {
                videos.add(video);
              }),
            Array.from(videos)
          );
        },
        primeForSound = (video) => {
          let promoted = !1;
          if (
            (video.querySelectorAll("source[data-src]").forEach((source) => {
              source.hasAttribute("src") ||
                ((source.src = source.dataset.src), (promoted = !0));
            }),
            promoted && ((video.dataset.hydrated = "true"), video.load()),
            !video.getAttribute("src"))
          ) {
            const mobile = video.dataset.srcMobile || "",
              desktop = video.dataset.srcDesktop || "",
              source = window.matchMedia("(min-width: 1024px)").matches
                ? desktop || mobile
                : mobile || desktop;
            source && (video.src = source);
          }
        },
        authorizeFromGesture = (triggerVideo, preserveTrigger = !1) => {
          !soundOn ||
            !triggerVideo ||
            qualifyingVideos().forEach((video) => {
              if (
                (preserveTrigger && video === triggerVideo) ||
                (primeForSound(video), typeof video.play != "function")
              )
                return;
              const wasPaused = video.paused;
              let attempt;
              try {
                attempt = video.play();
              } catch {
                return;
              }
              (wasPaused && video.pause(),
                attempt &&
                  typeof attempt.catch == "function" &&
                  attempt.catch(() => {}));
            });
        },
        set = (next, triggerVideo = null, preserveTrigger = !1) => {
          soundOn = !!next;
          try {
            window.sessionStorage.setItem(storageKey, soundOn ? "on" : "off");
          } catch {}
          return (
            sync(),
            authorizeFromGesture(triggerVideo, preserveTrigger),
            soundOn
          );
        },
        api = {
          get: () => soundOn,
          set,
          toggle: (triggerVideo) => set(!soundOn, triggerVideo),
          togglePreservingPlayback: (triggerVideo) =>
            set(!soundOn, triggerVideo, !0),
          sync,
          refresh: () => {
            const stored = read();
            return (stored !== null && (soundOn = stored), sync(), soundOn);
          },
        };
      return (
        window.addEventListener("pageshow", api.refresh),
        (window.NexCarouselSound = api),
        api
      );
    })();
  let nexInjected = !1,
    nexWired = !1,
    nexBtnRef = null;
  const navigationEntry = performance.getEntriesByType("navigation")[0];
  const savedScroll = history.state?.__nexScroll;
  let scrollSaveTimer = 0;
  let lastScrollSave = 0;
  let scrollSavingSuspended = document.hidden;
  let scrollSaveEnabled = !document.hidden && Boolean(window.NexStoryEntry?.interacted);
  let scrollCheckpoint = { x: scrollX, y: scrollY };
  const saveScroll = () => {
    clearTimeout(scrollSaveTimer);
    scrollSaveTimer = 0;
    if (scrollSavingSuspended || document.hidden) return;
    try {
      const state = history.state;
      if (state && (typeof state !== "object" || Array.isArray(state))) return;
      if (state?.__nexScroll?.x === scrollCheckpoint.x && state?.__nexScroll?.y === scrollCheckpoint.y) return;
      history.replaceState({ ...state, __nexScroll: { ...scrollCheckpoint } }, "");
      lastScrollSave = Date.now();
    } catch {}
  };
  const suspendScrollSaving = () => {
    clearTimeout(scrollSaveTimer);
    scrollSaveTimer = 0;
    scrollSavingSuspended = true;
    scrollSaveEnabled = false;
  };
  window.addEventListener("pagehide", suspendScrollSaving);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) suspendScrollSaving();
    else {
      scrollSavingSuspended = false;
      scrollSaveEnabled = false;
    }
  });
  ["touchstart", "wheel", "keydown", "pointerdown"].forEach((type) => {
    window.addEventListener(type, () => {
      if (document.hidden || scrollSavingSuspended) return;
      scrollSaveEnabled = true;
      scrollCheckpoint = { x: scrollX, y: scrollY };
    }, { passive: true });
  });
  // WebKit can omit pagehide when leaving before the page finishes loading.
  // Keep the last deliberate position while limiting history writes.
  window.addEventListener("scroll", () => {
    if (!scrollSaveEnabled || scrollSavingSuspended || document.hidden || stopHistoryRestore) return;
    scrollCheckpoint = { x: scrollX, y: scrollY };
    const remaining = 500 - (Date.now() - lastScrollSave);
    if (remaining <= 0) saveScroll();
    else if (!scrollSaveTimer) scrollSaveTimer = setTimeout(saveScroll, remaining);
  }, { passive: true });
  const flushVisibleScroll = () => {
    if (!scrollSaveEnabled || scrollSavingSuspended || document.hidden || stopHistoryRestore) return;
    scrollCheckpoint = { x: scrollX, y: scrollY };
    saveScroll();
  };
  ["click", "submit"].forEach((type) => {
    window.addEventListener(type, flushVisibleScroll, { capture: true, passive: true });
  });
  if (navigationEntry?.type !== "back_forward") saveScroll();
  let stopHistoryRestore;
  const startHistoryRestore = (restoreScroll, cached = false) => {
    stopHistoryRestore?.();
    if (!restoreScroll || !Number.isFinite(restoreScroll.y) || location.hash ||
        (!cached && window.NexStoryEntry?.interacted)) return;
    let finished = false;
    let observer;
    let timer;
    let settleTimer;
    let frame;
    const cachedSettleUntil = cached ? performance.now() + 750 : 0;
    const intents = ["touchstart", "wheel", "keydown", "pointerdown"];
    const finish = () => {
      finished = true;
      clearTimeout(timer);
      clearTimeout(settleTimer);
      cancelAnimationFrame(frame);
      observer?.disconnect();
      removeEventListener("load", restore);
      removeEventListener("scroll", restoreCachedScroll);
      removeEventListener("pagehide", finish);
      removeEventListener("hashchange", finish);
      intents.forEach((type) => removeEventListener(type, finish));
      if (stopHistoryRestore === finish) stopHistoryRestore = null;
    };
    const restore = () => {
      if (finished || location.hash || (!cached && window.NexStoryEntry?.interacted)) {
        finish();
        return;
      }
      clearTimeout(settleTimer);
      if (document.documentElement.scrollHeight - innerHeight + 2 < restoreScroll.y) return;
      window.scrollTo({ left: restoreScroll.x || 0, top: restoreScroll.y, behavior: "instant" });
      scrollCheckpoint = { x: restoreScroll.x || 0, y: restoreScroll.y };
      if (document.readyState === "complete") {
        settleTimer = setTimeout(finish, Math.max(120, cachedSettleUntil - performance.now()));
      }
    };
    const restoreCachedScroll = () => {
      // Safari can restore an old orientation's position after pageshow and resize.
      if (Math.abs(scrollY - restoreScroll.y) > 1 || Math.abs(scrollX - (restoreScroll.x || 0)) > 1) restore();
    };
    stopHistoryRestore = finish;
    intents.forEach((type) => addEventListener(type, finish, { passive: true, once: true }));
    addEventListener("load", restore, { once: true });
    addEventListener("pagehide", finish, { once: true });
    addEventListener("hashchange", finish, { once: true });
    if (cached) addEventListener("scroll", restoreCachedScroll, { passive: true });
    if ("ResizeObserver" in window) {
      observer = new ResizeObserver(restore);
      observer.observe(document.body);
      const hero = document.querySelector(".hero");
      if (hero) observer.observe(hero);
    }
    timer = setTimeout(finish, 5000);
    frame = requestAnimationFrame(() => { frame = requestAnimationFrame(restore); });
  };
  if (navigationEntry?.type === "back_forward") startHistoryRestore(savedScroll);
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      scrollSavingSuspended = false;
      scrollSaveEnabled = false;
      startHistoryRestore(history.state?.__nexScroll, true);
    }
    else if (navigationEntry?.type === "back_forward") startHistoryRestore(savedScroll);
  });
  const storyGuard = () => {
    const heroEl = document.querySelector(".hero[data-entrance], .lp-hero");
    const entry = window.NexStoryEntry;
    const navigation = performance.getEntriesByType("navigation")[0];
    if (!heroEl || location.hash || entry?.interacted || entry?.restored ||
        navigation?.type === "back_forward") return;
    let armed = true;
    let timer = 0;
    const intents = ["touchstart", "wheel", "keydown", "pointerdown"];
    const disarm = () => {
      armed = false;
      clearTimeout(timer);
      removeEventListener("scroll", veto);
      removeEventListener("pagehide", disarm);
      removeEventListener("load", settled);
      intents.forEach((type) => removeEventListener(type, disarm));
    };
    const veto = () => {
      if (!armed || location.hash || entry?.interacted || entry?.restored) {
        disarm();
        return;
      }
      if (window.scrollY > 0 && window.scrollY < heroEl.offsetHeight) {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
    };
    const settled = () => {
      veto();
      requestAnimationFrame(() => requestAnimationFrame(disarm));
    };
    addEventListener("scroll", veto, { passive: true });
    addEventListener("pagehide", disarm, { once: true });
    intents.forEach((type) => addEventListener(type, disarm, { passive: true, once: true }));
    timer = setTimeout(disarm, 10000);
    veto();
    if (document.readyState === "complete") settled();
    else addEventListener("load", settled, { once: true });
  };
  const start = () => {
    const header = document.querySelector(".site-header");
    if (!header) return null;
    carouselSound.sync();
    const off = [],
      cleanups = [];
    let dead = !1;
    const on = (t, e, f, o) => {
        (t.addEventListener(e, f, o),
          off.push(() => t.removeEventListener(e, f, o)));
      },
      onMq = (mq, f) => {
        mq.addEventListener
          ? (mq.addEventListener("change", f),
            off.push(() => mq.removeEventListener("change", f)))
          : mq.addListener &&
            (mq.addListener(f), off.push(() => mq.removeListener(f)));
      },
      watch = (obs, node, opts) => {
        (obs.observe(node, opts), off.push(() => obs.disconnect()));
      },
      deferredPictureSelector = "picture[data-responsive-image-defer]",
      deferredScopeSelector = "[data-responsive-image-defer-scope]",
      transferDeferredImageAttr = (node, dataName, liveName) => {
        const value = node.getAttribute(dataName);
        (value !== null && value !== "" && node.setAttribute(liveName, value),
          node.removeAttribute(dataName));
      },
      hydrateDeferredPicture = (picture) => {
        if (!picture || !picture.hasAttribute("data-responsive-image-defer"))
          return;
        picture.querySelectorAll("source[data-srcset]").forEach((source) => {
          (transferDeferredImageAttr(source, "data-sizes", "sizes"),
            transferDeferredImageAttr(source, "data-srcset", "srcset"));
        });
        const image = picture.querySelector("img");
        (image &&
          ((image.loading = "eager"),
          transferDeferredImageAttr(image, "data-sizes", "sizes"),
          transferDeferredImageAttr(image, "data-srcset", "srcset"),
          transferDeferredImageAttr(image, "data-src", "src")),
          picture.removeAttribute("data-responsive-image-defer"),
          picture.setAttribute("data-responsive-image-hydrated", ""));
      },
      hydrateDeferredScope = (scope) => {
        scope
          .querySelectorAll(deferredPictureSelector)
          .forEach(hydrateDeferredPicture);
      },
      hydrateAllDeferredPictures = () => {
        document
          .querySelectorAll(deferredPictureSelector)
          .forEach(hydrateDeferredPicture);
      },
      hydrateDeferredPicturesForPrint = () => {
        (document
          .querySelectorAll(`${deferredPictureSelector} img`)
          .forEach((image) => {
            image.loading = "eager";
          }),
          hydrateAllDeferredPictures());
      },
      deferredScopes = [...document.querySelectorAll(deferredScopeSelector)];
    if (!!document.querySelector(deferredPictureSelector)) {
      const designMode = !!(window.Shopify && window.Shopify.designMode);
      if (
        !designMode &&
        "IntersectionObserver" in window &&
        deferredScopes.length
      ) {
        const pendingDeferredScopes = new Set(deferredScopes);
        let deferredImageIo = null,
          deferredImageResizeT = 0;
        const armDeferredImageIo = () => {
            if (dead) return;
            if (
              (deferredImageIo && deferredImageIo.disconnect(),
              pendingDeferredScopes.forEach((scope) => {
                scope.querySelector(deferredPictureSelector) ||
                  pendingDeferredScopes.delete(scope);
              }),
              !pendingDeferredScopes.size)
            ) {
              deferredImageIo = null;
              return;
            }
            const viewportHeight = Math.max(
                1,
                window.innerHeight ||
                  document.documentElement.clientHeight ||
                  1,
              ),
              leadPx = Math.round(viewportHeight * 0.75);
            ((deferredImageIo = new IntersectionObserver(
              (entries) => {
                dead ||
                  entries.forEach((entry) => {
                    entry.isIntersecting &&
                      (hydrateDeferredScope(entry.target),
                      pendingDeferredScopes.delete(entry.target),
                      deferredImageIo &&
                        deferredImageIo.unobserve(entry.target));
                  });
              },
              { rootMargin: `${leadPx}px 0px`, threshold: 0 },
            )),
              pendingDeferredScopes.forEach((scope) =>
                deferredImageIo.observe(scope),
              ));
          },
          scheduleDeferredImageIo = () => {
            dead ||
              (clearTimeout(deferredImageResizeT),
              (deferredImageResizeT = setTimeout(armDeferredImageIo, 120)));
          };
        (armDeferredImageIo(),
          on(window, "resize", scheduleDeferredImageIo, { passive: !0 }),
          on(window, "orientationchange", scheduleDeferredImageIo, {
            passive: !0,
          }),
          window.visualViewport &&
            on(window.visualViewport, "resize", scheduleDeferredImageIo, {
              passive: !0,
            }),
          off.push(() => {
            (clearTimeout(deferredImageResizeT),
              deferredImageIo && deferredImageIo.disconnect(),
              (deferredImageIo = null),
              pendingDeferredScopes.clear());
          }));
      } else
        (designMode || !("IntersectionObserver" in window)) &&
          hydrateAllDeferredPictures();
      (on(window, "beforeprint", hydrateDeferredPicturesForPrint),
        on(window, "pageshow", (event) => {
          event.persisted && hydrateAllDeferredPictures();
        }));
    }
    const presentedFrameGate = (video, commit) => {
        let videoFrameId = null,
          paintFrameId = 0;
        return {
          request: () => {
            if (!(dead || videoFrameId !== null || paintFrameId)) {
              if (typeof video.requestVideoFrameCallback == "function") {
                videoFrameId = video.requestVideoFrameCallback(() => {
                  ((videoFrameId = null), dead || commit());
                });
                return;
              }
              paintFrameId = requestAnimationFrame(() => {
                paintFrameId = requestAnimationFrame(() => {
                  ((paintFrameId = 0),
                    !dead &&
                      !video.paused &&
                      !video.ended &&
                      video.readyState >= 2 &&
                      commit());
                });
              });
            }
          },
          cancel: () => {
            (videoFrameId !== null &&
              typeof video.cancelVideoFrameCallback == "function" &&
              video.cancelVideoFrameCallback(videoFrameId),
              (videoFrameId = null),
              paintFrameId && cancelAnimationFrame(paintFrameId),
              (paintFrameId = 0));
          },
        };
      },
      reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
      responsiveMediaMq = window.matchMedia("(min-width: 1024px)"),
      releaseDesktopWidgets = () => {
        const root = document.documentElement;
        !responsiveMediaMq.matches ||
          root.getAttribute("data-nex-widget-gate") !== "waiting" ||
          (root.setAttribute("data-nex-widget-gate", "ready"),
          document.dispatchEvent(
            new CustomEvent("nex:highlights-ready", {
              detail: { desktop: !0 },
            }),
          ));
      };
    (releaseDesktopWidgets(), onMq(responsiveMediaMq, releaseDesktopWidgets));
    const syncNativePoster = (video) => {
        const poster = responsiveMediaMq.matches
          ? video.dataset.posterDesktop
          : video.dataset.posterMobile || video.dataset.posterDesktop;
        poster
          ? video.getAttribute("poster") !== poster &&
            video.setAttribute("poster", poster)
          : video.hasAttribute("poster") && video.removeAttribute("poster");
      },
      syncResponsiveNativeMedia = (reloadSources = !1) => {
        (document
          .querySelectorAll(
            "video[data-poster-mobile], video[data-poster-desktop]",
          )
          .forEach((video) => {
            video.closest(".theater") ||
              video.hasAttribute("data-poster-defer") ||
              syncNativePoster(video);
          }),
          reloadSources &&
            document.querySelectorAll("video").forEach((video) => {
              const mediaSources = [...video.querySelectorAll("source")];
              if (
                !mediaSources.some((source) => source.hasAttribute("media")) ||
                video.hasAttribute("data-hero-desktop-video") ||
                video.closest(".theater")
              )
                return;
              const selected = mediaSources.find(
                  (source) =>
                    !source.media || window.matchMedia(source.media).matches,
                ),
                selectedUrl =
                  selected && selected.src
                    ? new URL(selected.src, location.href).href
                    : "",
                currentUrl = video.currentSrc
                  ? new URL(video.currentSrc, location.href).href
                  : "";
              if (selectedUrl && currentUrl === selectedUrl) return;
              const wasPlaying = !video.paused,
                priorTime = Number.isFinite(video.currentTime)
                  ? video.currentTime
                  : 0;
              (on(
                video,
                "loadedmetadata",
                () => {
                  (priorTime > 0 &&
                    Number.isFinite(video.duration) &&
                    video.duration > 0 &&
                    (video.currentTime = Math.min(
                      priorTime,
                      Math.max(0, video.duration - 0.05),
                    )),
                    wasPlaying &&
                      (!video.hasAttribute("data-hl-video") ||
                        video.hasAttribute("data-hl-should-play")) &&
                      video.play().catch(() => {}));
                },
                { once: !0 },
              ),
                video.load());
            }));
      };
    (syncResponsiveNativeMedia(),
      onMq(responsiveMediaMq, () => syncResponsiveNativeMedia(!0)));
    const deferredPosters = [
      ...document.querySelectorAll("video[data-poster-defer]"),
    ].filter((video) => !video.hasAttribute("data-hl-video"));
    if (deferredPosters.length) {
      const hydratePoster = (video) => {
        (video.removeAttribute("data-poster-defer"), syncNativePoster(video));
      };
      if ("IntersectionObserver" in window) {
        const posterIo = new IntersectionObserver(
          (entries) =>
            entries.forEach((entry) => {
              entry.isIntersecting &&
                (posterIo.unobserve(entry.target), hydratePoster(entry.target));
            }),
          { rootMargin: "400px 0px" },
        );
        (deferredPosters.forEach((video) => posterIo.observe(video)),
          off.push(() => posterIo.disconnect()));
      } else deferredPosters.forEach(hydratePoster);
    }
    if (document.documentElement.getAttribute("data-boot") === "pending") {
      const go = () =>
        requestAnimationFrame(() =>
          document.documentElement.setAttribute("data-boot", "go"),
        );
      if (reduced) go();
      else {
        const bag = document.querySelector(".hero__bag"),
          criticalFonts =
            document.fonts && document.fonts.load
              ? Promise.all([
                  document.fonts.load('700 1em "Nex"', "M1 CHEST BAG"),
                  document.fonts.load(
                    document.querySelector(".hero[data-entrance]")
                      ? '500 1em "Red Hat Display"'
                      : '400 1em "Red Hat Display"',
                    "Meetnex",
                  ),
                ]).catch(() => {})
              : Promise.resolve(),
          ready = Promise.all([
            criticalFonts,
            bag && bag.decode
              ? bag.decode().catch(() => {})
              : Promise.resolve(),
          ]);
        Promise.race([ready, new Promise((r) => setTimeout(r, 900))]).then(go);
      }
    }
    const bez = (x1, y1, x2, y2) => {
      const cx = 3 * x1,
        bx = 3 * (x2 - x1) - cx,
        ax = 1 - cx - bx,
        cy = 3 * y1,
        by = 3 * (y2 - y1) - cy,
        ay = 1 - cy - by,
        X = (t) => ((ax * t + bx) * t + cx) * t;
      return (x) => {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        let lo = 0,
          hi = 1;
        for (let i = 0; i < 22; i++) {
          const m = (lo + hi) / 2;
          X(m) < x ? (lo = m) : (hi = m);
        }
        const t = (lo + hi) / 2;
        return ((ay * t + by) * t + cy) * t;
      };
    };
    let schemeHeld = !1;
    const syncSchemeNow = () => {
      if (schemeHeld) return;
      const y = header.offsetHeight / 2;
      let scheme = "light";
      for (const el of document.querySelectorAll("[data-header-scheme]")) {
        const r = el.getBoundingClientRect();
        if (r.top <= y && r.bottom >= y) {
          scheme = el.dataset.headerScheme;
          break;
        }
      }
      header.getAttribute("data-scheme") !== scheme &&
        header.setAttribute("data-scheme", scheme);
    };
    let schemePend = 0;
    (on(
      window,
      "scroll",
      () => {
        schemePend ||
          (schemePend = requestAnimationFrame(() => {
            ((schemePend = 0), syncSchemeNow());
          }));
      },
      { passive: !0 },
    ),
      cleanups.push(() => cancelAnimationFrame(schemePend)));
    let lockCount = 0,
      tX0 = 0,
      tY0 = 0,
      tAxis = null;
    const touchOrigin = (e) => {
        const t = e.touches && e.touches[0];
        (t && ((tX0 = t.clientX), (tY0 = t.clientY)), (tAxis = null));
      },
      gestureBlock = (e) => {
        const tg = e.target;
        if (
          !(tg && tg.closest && tg.closest("nex-gdab")) &&
          !(tg && tg.closest && tg.closest(".wn__fly")) &&
          !(tg && tg.closest && tg.closest(".f3 .detail-modal"))
        ) {
          if (tg && tg.closest && tg.closest(".dm__nav")) {
            if (tAxis === null) {
              const t = e.touches && e.touches[0],
                dx = t ? Math.abs(t.clientX - tX0) : 0,
                dy = t ? Math.abs(t.clientY - tY0) : 0;
              if (dx < 3 && dy < 3) {
                e.preventDefault();
                return;
              }
              tAxis = dx > dy ? "x" : "y";
            }
            if (tAxis === "x") return;
          }
          e.preventDefault();
        }
      },
      wheelBlock = (e) => {
        const t = e.target;
        (t && t.closest && t.closest("nex-gdab")) ||
          (t && t.closest && t.closest(".wn__fly")) ||
          (t &&
            t.closest &&
            t.closest(".dm__nav") &&
            Math.abs(e.deltaX) > Math.abs(e.deltaY)) ||
          e.preventDefault();
      },
      NAV_KEYS = [
        " ",
        "PageUp",
        "PageDown",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ],
      keyBlock = (e) => {
        if (NAV_KEYS.indexOf(e.key) === -1) return;
        const t = e.target;
        (t && t.closest && t.closest("nex-gdab")) ||
          (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) ||
          (e.key === " " &&
            t &&
            t.closest &&
            t.closest('button, a, [role="button"], .site-header')) ||
          e.preventDefault();
      },
      lockScroll = () => {
        lockCount++ === 0 &&
          (document.documentElement.classList.add("page-locked"),
          document.addEventListener("touchstart", touchOrigin, { passive: !0 }),
          document.addEventListener("touchmove", gestureBlock, { passive: !1 }),
          document.addEventListener("wheel", wheelBlock, { passive: !1 }),
          document.addEventListener("keydown", keyBlock, !0));
      },
      unlockScroll = () => {
        --lockCount <= 0 &&
          ((lockCount = 0),
          document.documentElement.classList.remove("page-locked"),
          document.removeEventListener("touchstart", touchOrigin, {
            passive: !0,
          }),
          document.removeEventListener("touchmove", gestureBlock, {
            passive: !1,
          }),
          document.removeEventListener("wheel", wheelBlock, { passive: !1 }),
          document.removeEventListener("keydown", keyBlock, !0));
      },
      pageLocked = () =>
        lockCount > 0 ||
        document.documentElement.classList.contains("gdab-scroll-lock"),
      settleMachines = [],
      makeSettle = (attr, geom) => {
        const html = document.documentElement;
        let t = 0;
        const arm = (on2) => {
            html.hasAttribute(attr) !== on2 && html.toggleAttribute(attr, on2);
          },
          evalNow = () => {
            if (!storyScrollIntent) {
              arm(false);
              return;
            }
            if (m.touching || pageLocked()) return;
            const g = geom();
            if (!g || g.range <= 0) {
              arm(!1);
              return;
            }
            if (g.y >= g.range - 2 || g.y < -2) {
              arm(!1);
              return;
            }
            let beat = 0;
            for (const b of g.beats)
              Math.abs(g.y - b) < Math.abs(g.y - beat) && (beat = b);
            if (Math.abs(g.y - beat) <= 2) {
              arm(beat < g.range - 2 && !(beat <= 2 && window.scrollY > 2));
              return;
            }
            (arm(!0),
              window.scrollTo({
                top: window.scrollY + g.top + beat,
                behavior: "smooth",
              }),
              m.kick());
          },
          m = {
            touching: !1,
            now: evalNow,
            release() {
              (clearTimeout(t), arm(!1));
            },
            kick() {
              clearTimeout(t);
              const y0 = window.scrollY;
              t = setTimeout(() => {
                if (Math.abs(window.scrollY - y0) > 1) {
                  m.kick();
                  return;
                }
                evalNow();
              }, 140);
            },
            stop() {
              clearTimeout(t);
            },
          };
        return (settleMachines.push(m), m);
      };
    let storyScrollIntent = false;
    const markStoryScrollIntent = (event) => {
      if (event.type === "keydown" &&
          (!NAV_KEYS.includes(event.key) ||
           event.target?.closest?.("input, textarea, select, button, a, [role='button'], [contenteditable], nex-gdab"))) return;
      storyScrollIntent = true;
    };
    on(window, "wheel", markStoryScrollIntent, { passive: true });
    on(window, "touchmove", markStoryScrollIntent, { passive: true });
    on(window, "keydown", markStoryScrollIntent);
    const resetStoryScrollIntent = () => {
      storyScrollIntent = false;
      settleMachines.forEach((machine) => machine.release());
    };
    on(window, "pagehide", resetStoryScrollIntent);
    on(window, "pageshow", (event) => {
      if (event.persisted) resetStoryScrollIntent();
    });
    cleanups.push(() => settleMachines.forEach((m) => m.stop()));
    const touchGate = (down) => (e) => {
      (!down && e.touches && e.touches.length) ||
        settleMachines.forEach((m) => {
          ((m.touching = down), down ? m.stop() : m.kick());
        });
    };
    (on(window, "touchstart", touchGate(!0), { passive: !0 }),
      on(window, "touchend", touchGate(!1), { passive: !0 }),
      on(window, "touchcancel", touchGate(!1), { passive: !0 }));
    const inertOutside = (root, exempt) => {
        const touched = [];
        let node = root;
        for (; node && node.parentElement; ) {
          const parent = node.parentElement;
          if (
            ([...parent.children].forEach((el) => {
              if (
                !(
                  el === node ||
                  /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)
                )
              ) {
                for (const sel of exempt)
                  if (el.matches(sel) || el.querySelector(sel)) return;
                (touched.push(el),
                  "inert" in el
                    ? (el.inert = !0)
                    : el.setAttribute("aria-hidden", "true"));
              }
            }),
            parent === document.body)
          )
            break;
          node = parent;
        }
        return touched;
      },
      inertRestore = (els) =>
        els.forEach((el) => {
          "inert" in el ? (el.inert = !1) : el.removeAttribute("aria-hidden");
        }),
      hero = document.querySelector(".hero[data-entrance]");
    if (hero) {
      let highlightsReached = !1;
      const publishHighlightsReady = () => {
          highlightsReached ||
            ((highlightsReached = !0),
            hero.setAttribute("data-hl-reached", ""),
            document.documentElement.setAttribute(
              "data-nex-widget-gate",
              "ready",
            ),
            document.dispatchEvent(
              new CustomEvent("nex:highlights-ready", { detail: { hero } }),
            ));
        },
        stage = hero.querySelector(".hero__stage") || hero,
        story = hero.querySelector(".hero__story") || hero,
        teaserBtn = hero.querySelector("button.hero__teaser");
      let teaserAccess = null;
      const syncTeaserAccess = (enabled) => {
        !teaserBtn ||
          teaserAccess === enabled ||
          ((teaserAccess = enabled),
          (teaserBtn.disabled = !enabled),
          (teaserBtn.tabIndex = enabled ? 0 : -1),
          (teaserBtn.style.pointerEvents = enabled ? "" : "none"),
          enabled
            ? teaserBtn.removeAttribute("aria-hidden")
            : teaserBtn.setAttribute("aria-hidden", "true"));
      };
      cleanups.push(() => {
        teaserBtn &&
          ((teaserBtn.disabled = !1),
          teaserBtn.removeAttribute("tabindex"),
          teaserBtn.removeAttribute("aria-hidden"),
          teaserBtn.style.removeProperty("pointer-events"));
      });
      const gdabEl = document.querySelector(
          "nex-gdab:not([data-gdab-duplicate])",
        ),
        heroPurchase = hero.querySelector("nex-hero-purchase.hero-purchase"),
        heroDockMorph = (() => {
          if (!heroPurchase || !gdabEl) return null;
          const gdabForm = gdabEl.querySelector(".gdab__form"),
            gdabPill = gdabEl.querySelector(".gdab__pill"),
            gdabNexie = gdabEl.querySelector(".gdab__nexie"),
            actions = heroPurchase.querySelector(".hero-purchase__actions"),
            product = heroPurchase.querySelector(".hero-purchase__product-shell");
          if (!gdabForm || !gdabPill || !gdabNexie || !actions || !product) return null;
          const smooth = (value) => {
              const p = Math.max(0, Math.min(1, value));
              return p * p * (3 - 2 * p);
            },
            mobile = () => !responsiveMediaMq.matches,
            setHidden = (node, hidden) => {
              node.inert = hidden;
              hidden ? node.setAttribute("aria-hidden", "true")
                : node.removeAttribute("aria-hidden");
            };
          let geometry = null, lastT = 0, phase = "", dockLive = false,
            measureFrame = 0, retiringFocus = null;
          const reset = () => {
              geometry = null;
              hero.removeAttribute("data-purchase-handoff");
              ["opacity", "visibility", "transition"].forEach(name => actions.style.removeProperty(name));
              ["data-hero-morph-target", "data-hero-morph-ready",
                "data-hero-source-visible", "data-hero-nexie-ready"].forEach(
                name => gdabEl.removeAttribute(name),
              );
              ["--hero-dock-form-opacity", "--hero-dock-form-x", "--hero-dock-form-y",
                "--hero-dock-nexie-opacity", "--hero-dock-nexie-x", "--hero-dock-nexie-y",
                "--hero-dock-nexie-scale", "--hero-dock-pill-width", "--hero-dock-pill-height",
                "--hero-dock-pill-radius", "--hero-dock-content-opacity",
                "--hero-dock-shadow-alpha"].forEach(name => gdabEl.style.removeProperty(name));
              document.documentElement.removeAttribute("data-hero-morph-state");
              gdabEl.setHeroMorphState && gdabEl.setHeroMorphState("");
              setHidden(heroPurchase, false);
              setHidden(gdabEl, false);
              gdabNexie.inert = false;
              retiringFocus = null;
              phase = "";
              dockLive = false;
            },
            measure = () => {
              if (!mobile()) {
                (phase || geometry) && reset();
                return;
              }
              // Native document flow carries the complete hero into Highlights.
              // There is no pinned waiting interval, moving copy, or resized card.
              hero.setAttribute("data-purchase-handoff", "");
              gdabEl.setAttribute("data-hero-morph-target", "");
              const style = getComputedStyle(gdabEl),
                sourceRect = heroPurchase.getBoundingClientRect(),
                heroTop = hero.getBoundingClientRect().top,
                actionTop = actions.getBoundingClientRect().top - heroTop,
                productBottom = product.getBoundingClientRect().bottom - heroTop,
                header = document.querySelector(".site-header"),
                headerBottom = Math.max(0, header ? header.getBoundingClientRect().bottom : 0),
                targetWidth = gdabForm.offsetWidth - gdabNexie.offsetWidth -
                  (parseFloat(style.getPropertyValue("--gdab-gap")) || 10);
              if (!sourceRect.width || !sourceRect.height || targetWidth <= 0) return;
              // The source row retires just before the fixed header can cover
              // it. The real, fixed dock is already usable throughout its reveal.
              geometry = {
                end: Math.max(1, actionTop - headerBottom - 12),
                productEnd: productBottom - headerBottom,
              };
              gdabEl.style.setProperty("--hero-dock-pill-width", targetWidth.toFixed(3) + "px");
              gdabEl.style.setProperty("--hero-dock-pill-height",
                (parseFloat(style.getPropertyValue("--gdab-height")) || 68) + "px");
              gdabEl.style.setProperty("--hero-dock-pill-radius",
                (parseFloat(style.getPropertyValue("--gdab-radius")) || 34) + "px");
              ["--hero-dock-form-x", "--hero-dock-form-y", "--hero-dock-nexie-x",
                "--hero-dock-nexie-y"].forEach(name => gdabEl.style.setProperty(name, "0px"));
              gdabEl.style.setProperty("--hero-dock-nexie-scale", "1");
              gdabEl.style.setProperty("--hero-dock-content-opacity", "1");
              gdabEl.style.setProperty("--hero-dock-shadow-alpha", ".1");
            },
            render = (time) => {
              lastT = time;
              if (!mobile()) {
                (phase || geometry) && reset();
                return;
              }
              if (!geometry) measure();
              if (!geometry) return;
              const y = Math.max(0, -hero.getBoundingClientRect().top),
                revealDistance = Math.min(80, geometry.end),
                // Quantize before gating access: WebKit serializes extremely
                // small alpha as zero, which must not leave an invisible tab stop.
                opacity = reduced ? (y >= geometry.end ? 1 : 0)
                  : Math.round(smooth((y - geometry.end + revealDistance) / revealDistance) * 10000) / 10000,
                sourceAlpha = reduced ? (y >= geometry.end ? 0 : 1)
                  : Math.round((1 - smooth((y - geometry.end + Math.min(40, geometry.end)) / Math.min(40, geometry.end))) * 10000) / 10000,
                sourceLive = sourceAlpha > 0,
                nextDockLive = opacity > 0,
                nextPhase = y <= 0 ? "source" : sourceLive ? "active" : "target",
                modalOpen = gdabEl.state === "cart" || gdabEl.state === "panel",
                active = document.activeElement;
              // A deliberate newer focus choice outside this purchase handoff
              // always wins over a previously retiring source/dock control.
              if (retiringFocus && active && active !== document.body &&
                  active !== document.documentElement && !active.closest("[inert]") &&
                  !heroPurchase.contains(active) && !gdabEl.contains(active)) retiringFocus = null;
              actions.style.opacity = String(sourceAlpha);
              actions.style.transition = "none";
              // Opacity and the parent's inert/ARIA gate are sufficient.
              // Toggling inherited visibility starts a WebKit child transition
              // that can outlive an atomic reduced-motion reversal.
              actions.style.removeProperty("visibility");
              gdabEl.toggleAttribute("data-hero-source-visible", y < geometry.productEnd);
              document.documentElement.setAttribute("data-hero-morph-state", nextPhase);
              if (phase !== nextPhase || dockLive !== nextDockLive) {
                // Release the independent boot/focus gates on the same frame
                // the offer becomes visible. Source access is separate.
                gdabEl.setHeroMorphState &&
                  gdabEl.setHeroMorphState(nextDockLive ? "target" : nextPhase);
              }
              phase = nextPhase;
              dockLive = nextDockLive;
              gdabEl.style.setProperty("--hero-dock-form-opacity", String(opacity));
              gdabEl.style.setProperty("--hero-dock-nexie-opacity", String(opacity));
              gdabEl.toggleAttribute("data-hero-morph-ready", dockLive);
              gdabEl.toggleAttribute("data-hero-nexie-ready", dockLive);
              if (!modalOpen) {
                if (active && ((!sourceLive && heroPurchase.contains(active)) ||
                    (!dockLive && gdabEl.contains(active)))) {
                  retiringFocus = active;
                  active.blur && active.blur();
                }
                setHidden(heroPurchase, !sourceLive);
                setHidden(gdabEl, !dockLive);
                gdabNexie.inert = !dockLive;
                if (retiringFocus) {
                  let candidate = retiringFocus;
                  if (!candidate.isConnected || candidate.closest("[inert]")) {
                    candidate = dockLive ? gdabPill
                      : heroPurchase.querySelector(".hero-purchase__checkout");
                  }
                  if (candidate && !candidate.closest("[inert]")) {
                    candidate.focus({ preventScroll: true });
                    retiringFocus = null;
                  }
                }
              } else {
                // Modal page locking retains ownership of background inertness.
                setHidden(gdabEl, false);
              }
              gdabEl.syncSurfaceNow && gdabEl.syncSurfaceNow();
            },
            scheduleMeasure = () => {
              measureFrame && cancelAnimationFrame(measureFrame);
              measureFrame = requestAnimationFrame(() => {
                measureFrame = 0;
                measure();
                render(lastT);
              });
            };
          if ("ResizeObserver" in window) {
            const observer = new ResizeObserver(scheduleMeasure);
            observer.observe(heroPurchase);
            observer.observe(product);
            cleanups.push(() => observer.disconnect());
          }
          return (
            onMq(responsiveMediaMq, scheduleMeasure),
            on(gdabEl, "gdab:cart-open", () => render(lastT)),
            on(gdabEl, "gdab:panel-open", () => render(lastT)),
            on(gdabEl, "gdab:close", () => render(lastT)),
            on(window, "resize", scheduleMeasure, { passive: true }),
            window.visualViewport && on(window.visualViewport, "resize", scheduleMeasure, { passive: true }),
            cleanups.push(() => { measureFrame && cancelAnimationFrame(measureFrame); reset(); }),
            scheduleMeasure(),
            { render, jump: target => render(target ? 1376.35 : 0), measure: scheduleMeasure }
          );
        })(),
        highlightsRoot = document.querySelector("[data-highlights-section]") || hero,
        hl = highlightsRoot.querySelector("[data-hl]");
      let hlIdx = 0;
      // Surface colors follow the actual section under the header/dock.
      // Highlights never takes ownership of the intro's scroll playhead.
      const applyCtx = () => {
        gdabEl && gdabEl.refreshSurfaces && gdabEl.refreshSurfaces();
        syncSchemeNow();
      };
      highlightsRoot.setAttribute("data-hl-live", "");
      onMq(responsiveMediaMq, applyCtx);
      let hlSpringId = 0,
        hlSpringTarget = null,
        hlSetFocusable = null,
        hlSyncMedia = null,
        hlPrepareWindow = null;
      if (hl) {
        let pend = 0,
          settleT = null,
          drag = null,
          restoreId = 0;
        const hlPanels2 = Array.from(hl.children),
          hlDots = Array.from(highlightsRoot.querySelectorAll("[data-hl-dot]")),
          hlPrev = highlightsRoot.querySelector("[data-hl-prev]"),
          hlNext = highlightsRoot.querySelector("[data-hl-next]"),
          hlSr = highlightsRoot.querySelector("[data-hl-live-region]");
        let hlStep = 1,
          hlVisible = 1,
          hlMaxStart = Math.max(0, hlPanels2.length - 1),
          hlActive = 0,
          hlControlsFocusable = !1,
          hlInView = !("IntersectionObserver" in window);
        const sstep = (v) => v * v * (3 - 2 * v),
          hlLiveOk = () => highlightsRoot.hasAttribute("data-hl-live"),
          hlVideos = hlPanels2.map((panel) =>
            panel.querySelector("[data-hl-video]"),
          ),
          hlSoundButtons = hlPanels2.map((panel) =>
            panel.querySelector("[data-hl-video-sound]"),
          );
        let hlManualVideoIndex = null;
        const prepareHlPoster = (index) => {
          const video = hlVideos[index];
          video &&
            (video.removeAttribute("data-poster-defer"),
            syncNativePoster(video));
        };
        const prepareHlPanelMedia = (index) => {
            const panel = hlPanels2[index];
            panel &&
              (prepareHlPoster(index),
              panel
                .querySelectorAll(deferredPictureSelector)
                .forEach(hydrateDeferredPicture));
          },
          prepareHlWindow = (active = hlActive) => {
            const start2 = Math.max(0, active - 1),
              end = Math.min(hlPanels2.length, active + hlVisible + 1);
            for (let k = start2; k < end; k += 1) prepareHlPanelMedia(k);
          };
        hlPrepareWindow = prepareHlWindow;
        const prepareHlTravelWindow = (target = hlActive) => {
            const start2 = Math.max(0, Math.min(hlActive, target) - 1),
              end = Math.min(
                hlPanels2.length,
                Math.max(hlActive + hlVisible, target + hlVisible) + 1,
              );
            for (let k = start2; k < end; k += 1) prepareHlPanelMedia(k);
          },
          hydrateHlVideo = (video) => {
            !video ||
              video.dataset.hydrated === "true" ||
              (video.querySelectorAll("source[data-src]").forEach((source) => {
                source.src = source.dataset.src;
              }),
              (video.dataset.hydrated = "true"),
              video.load());
          };
        ((hlSyncMedia = () => {
          const visibleIndices = [],
            visibleEnd = Math.min(hlPanels2.length, hlActive + hlVisible);
          for (let k = hlActive; k < visibleEnd; k += 1) visibleIndices.push(k);
          const liveAndVisible = hlLiveOk() && hlInView && !document.hidden;
          (liveAndVisible && prepareHlWindow(),
            hlManualVideoIndex !== null &&
              !visibleIndices.includes(hlManualVideoIndex) &&
              (hlManualVideoIndex = null));
          const chosenIndex =
              hlManualVideoIndex !== null && hlVideos[hlManualVideoIndex]
                ? hlManualVideoIndex
                : visibleIndices.find((index) => !!hlVideos[index]),
            chosen = chosenIndex === void 0 ? null : hlVideos[chosenIndex],
            chosenByUser = !!(chosen && chosen.dataset.hlUserIntent === "true"),
            mayPlay = !!chosen && liveAndVisible && (!reduced || chosenByUser);
          hlVideos.forEach((video, index) => {
            if (!video) return;
            const soundButton = hlSoundButtons[index],
              panelIsVisible = visibleIndices.includes(index),
              canInteract = hlLiveOk() && panelIsVisible,
              shouldPlay = video === chosen && mayPlay;
            if (
              (video.toggleAttribute("data-hl-should-play", shouldPlay),
              soundButton &&
                ((soundButton.disabled = !canInteract),
                (soundButton.tabIndex = canInteract ? 0 : -1),
                soundButton.toggleAttribute("data-sound", !video.muted),
                soundButton.setAttribute("aria-pressed", String(!video.muted)),
                soundButton.setAttribute(
                  "aria-label",
                  video.muted
                    ? soundButton.dataset.labelOn || "Turn sound on"
                    : soundButton.dataset.labelOff || "Turn sound off",
                ),
                !canInteract && document.activeElement === soundButton))
            ) {
              const fallback = hlNext && !hlNext.disabled ? hlNext : hlPrev;
              fallback && fallback.focus();
            }
            shouldPlay
              ? (prepareHlPoster(index),
                hydrateHlVideo(video),
                video.paused &&
                  video.play().catch(() => {
                    video.removeAttribute("data-hl-should-play");
                  }))
              : video.pause();
          });
        }),
          hlSoundButtons.forEach((soundButton, index) => {
            soundButton &&
              (on(soundButton, "pointerdown", (event) =>
                event.stopPropagation(),
              ),
              on(
                soundButton,
                "touchstart",
                (event) => event.stopPropagation(),
                { passive: !0 },
              ),
              on(soundButton, "click", (event) => {
                event.stopPropagation();
                const video = hlVideos[index];
                video &&
                  ((hlManualVideoIndex = index),
                  (video.dataset.hlUserIntent = "true"),
                  carouselSound.toggle(video),
                  prepareHlPoster(index),
                  hlSyncMedia());
              }));
          }),
          "IntersectionObserver" in window &&
            watch(
              new IntersectionObserver(
                (entries) => {
                  ((hlInView = entries.some((entry) => entry.isIntersecting)),
                    hlSyncMedia());
                },
                { threshold: 0.01 },
              ),
              hl,
            ),
          on(document, "visibilitychange", hlSyncMedia));
        const refreshHlGeometry = () => {
          const cssVisible = parseInt(
            getComputedStyle(highlightsRoot).getPropertyValue("--hl-visible"),
            10,
          );
          ((hlVisible = Math.max(
            1,
            Math.min(
              hlPanels2.length,
              Number.isFinite(cssVisible) ? cssVisible : 1,
            ),
          )),
            (hlStep = Math.max(
              1,
              hlPanels2.length > 1
                ? hlPanels2[1].offsetLeft - hlPanels2[0].offsetLeft
                : hlPanels2[0]
                  ? hlPanels2[0].offsetWidth
                  : hl.clientWidth,
            )),
            (hlMaxStart = Math.max(0, hlPanels2.length - hlVisible)),
            hlDots.forEach((d, k) => {
              const unavailable = k > hlMaxStart;
              ((d.hidden = unavailable),
                d.setAttribute("aria-hidden", unavailable ? "true" : "false"),
                (d.tabIndex = hlControlsFocusable && !unavailable ? 0 : -1));
            }));
        };
        refreshHlGeometry();
        const writeVisual = () => {
            pend = 0;
            const pos = hl.scrollLeft / Math.max(1, hlStep),
              vi = Math.max(0, Math.min(hlMaxStart, Math.round(pos)));
            vi !== hlIdx &&
              ((hlIdx = vi),
              hlDots.forEach((d, k) => {
                k === vi
                  ? d.setAttribute("aria-current", "true")
                  : d.removeAttribute("aria-current");
              }),
              applyCtx());
            const firstT = Math.max(0, Math.min(1, pos));
            (highlightsRoot.style.setProperty(
              "--nh-beige-progress",
              String(reduced ? +(firstT >= 0.5) : sstep(firstT)),
            ),
              hlPanels2.forEach((p, i) => {
                const rel = i - pos,
                  dist =
                    hlVisible > 1
                      ? Math.min(
                          1,
                          Math.max(0, rel < 0 ? -rel : rel - (hlVisible - 1)),
                        )
                      : Math.min(1, Math.abs(rel)),
                  presence = 1 - sstep(dist);
                (p.style.setProperty(
                  "--nh-group-x",
                  reduced || hlVisible > 1
                    ? "0px"
                    : `${Math.max(-1.2, Math.min(1.2, rel)) * 32}px`,
                ),
                  p.style.setProperty(
                    "--nh-group-y",
                    reduced ? "0px" : `${dist * 4}px`,
                  ),
                  p.style.setProperty(
                    "--nh-group-scale",
                    reduced ? "1" : String(0.985 + presence * 0.015),
                  ),
                  p.style.setProperty(
                    "--nh-group-opacity",
                    reduced ? "1" : String(0.6 + presence * 0.4),
                  ),
                  rel >= -1.08 && rel <= hlVisible + 0.08
                    ? p.setAttribute("data-nh-near", "")
                    : p.removeAttribute("data-nh-near"));
              }));
          },
          reqVisual = () => {
            pend || (pend = requestAnimationFrame(writeVisual));
          },
          hlCommit = (i, silent) => {
            const index = Math.max(0, Math.min(hlMaxStart, i));
            hlActive = index;
            const focused = document.activeElement;
            if (
              (hlPrev && (hlPrev.disabled = index === 0),
              hlNext && (hlNext.disabled = index === hlMaxStart),
              hlPrev &&
                hlNext &&
                (focused === hlPrev && hlPrev.disabled
                  ? hlNext.focus()
                  : focused === hlNext && hlNext.disabled && hlPrev.focus()),
              hlPanels2.forEach((p, k) => {
                k >= index && k < index + hlVisible
                  ? p.setAttribute("aria-hidden", "false")
                  : p.setAttribute("aria-hidden", "true");
              }),
              hlSr && !silent)
            ) {
              const t = `Highlight ${hlPanels2[index].getAttribute("aria-label") || `${index + 1} of ${hlPanels2.length}`}`;
              hlSr.textContent !== t && (hlSr.textContent = t);
            }
            hlSyncMedia();
          };
        let hlTouch = !1;
        (on(
          hl,
          "touchstart",
          () => {
            (hlLiveOk() && prepareHlWindow(),
              (hlTouch = !0),
              hlSpringId &&
                (cancelAnimationFrame(hlSpringId), (hlSpringId = 0)),
              (hlSpringTarget = null),
              (hl.style.scrollSnapType = ""));
          },
          { passive: !0 },
        ),
          on(
            hl,
            "touchend",
            () => {
              ((hlTouch = !1),
                settleT && clearTimeout(settleT),
                (settleT = setTimeout(finishNearest, 150)));
            },
            { passive: !0 },
          ),
          on(
            hl,
            "touchcancel",
            () => {
              hlTouch = !1;
            },
            { passive: !0 },
          ));
        let offTries = 0;
        const finishNearest = () => {
            if (drag || hlSpringId || hlTouch) return;
            refreshHlGeometry();
            const index = Math.max(
              0,
              Math.min(hlMaxStart, Math.round(hl.scrollLeft / hlStep)),
            );
            if (!(Math.abs(hl.scrollLeft - index * hlStep) > 2)) {
              ((offTries = 0), (hl.style.scrollSnapType = ""), hlCommit(index));
              return;
            }
            if (hl.style.scrollSnapType === "none") {
              ((offTries = 0), springTo(index));
              return;
            }
            if (((offTries += 1), offTries >= 4)) {
              ((offTries = 0), springTo(index));
              return;
            }
            (settleT && clearTimeout(settleT),
              (settleT = setTimeout(finishNearest, 120)));
          },
          springTo = (reqIdx, v0 = 0) => {
            const index = Math.max(0, Math.min(hlMaxStart, reqIdx));
            if (
              (hlLiveOk() && hlInView && prepareHlTravelWindow(index),
              hlSpringId &&
                (cancelAnimationFrame(hlSpringId), (hlSpringId = 0)),
              (hlSpringTarget = index),
              reduced)
            ) {
              ((hl.style.scrollSnapType = ""),
                (hl.scrollLeft = index * hlStep),
                reqVisual(),
                hlCommit(index),
                (hlSpringTarget = null));
              return;
            }
            hl.style.scrollSnapType = "none";
            let x = hl.scrollLeft,
              v = v0,
              prevTs = performance.now();
            const step = (now) => {
              const dt = Math.min(0.032, Math.max(0.001, (now - prevTs) / 1e3));
              prevTs = now;
              const targetX = index * hlStep,
                a = 260 * (targetX - x) - 32.3 * v;
              if (
                ((v += a * dt),
                (x += v * dt),
                (hl.scrollLeft = x),
                reqVisual(),
                Math.abs(targetX - x) < 0.5 && Math.abs(v) < 8)
              ) {
                ((hl.scrollLeft = targetX),
                  (hl.style.scrollSnapType = ""),
                  (hlSpringId = 0),
                  (hlSpringTarget = null),
                  reqVisual(),
                  hlCommit(index));
                return;
              }
              hlSpringId = requestAnimationFrame(step);
            };
            hlSpringId = requestAnimationFrame(step);
          };
        (on(
          hl,
          "scroll",
          () => {
            (reqVisual(),
              settleT && clearTimeout(settleT),
              (settleT = setTimeout(finishNearest, 150)));
          },
          { passive: !0 },
        ),
          on(hl, "scrollend", finishNearest),
          on(hl, "pointerdown", (e) => {
            (hlSpringId && (cancelAnimationFrame(hlSpringId), (hlSpringId = 0)),
              (hlSpringTarget = null),
              !(e.pointerType === "touch" || e.button !== 0 || !hlLiveOk()) &&
                (prepareHlWindow(),
                (hl.style.scrollSnapType = "none"),
                hl.setPointerCapture(e.pointerId),
                hl.setAttribute("data-nh-dragging", ""),
                (drag = {
                  id: e.pointerId,
                  startX: e.clientX,
                  startScroll: hl.scrollLeft,
                  startIndex: Math.round(hl.scrollLeft / hlStep),
                  lastTime: performance.now(),
                  lastScroll: hl.scrollLeft,
                  velocity: 0,
                  moved: !1,
                })));
          }),
          on(hl, "pointermove", (e) => {
            if (!drag || e.pointerId !== drag.id) return;
            const nextScroll = Math.max(
                0,
                Math.min(
                  hlMaxStart * hlStep,
                  drag.startScroll - (e.clientX - drag.startX),
                ),
              ),
              now = performance.now(),
              elapsed = Math.max(1, now - drag.lastTime);
            ((drag.velocity =
              drag.velocity * 0.72 +
              ((nextScroll - drag.lastScroll) / elapsed) * 0.28),
              (drag.lastScroll = nextScroll),
              (drag.lastTime = now),
              (drag.moved =
                drag.moved || Math.abs(e.clientX - drag.startX) > 4),
              (hl.scrollLeft = nextScroll),
              drag.moved && e.preventDefault());
          }));
        const endDrag = (e) => {
          if (!drag || e.pointerId !== drag.id) return;
          (hl.hasPointerCapture(e.pointerId) &&
            hl.releasePointerCapture(e.pointerId),
            hl.removeAttribute("data-nh-dragging"));
          const d = drag;
          if (((drag = null), !hlLiveOk())) {
            springTo(0);
            return;
          }
          const dist = hl.scrollLeft - d.startScroll,
            intent =
              Math.abs(dist) >= hlStep * 0.14 || Math.abs(d.velocity) >= 0.45,
            dir = Math.sign(Math.abs(d.velocity) >= 0.45 ? d.velocity : dist);
          springTo(
            intent ? d.startIndex + dir : d.startIndex,
            d.velocity * 1e3,
          );
        };
        (on(hl, "pointerup", endDrag), on(hl, "pointercancel", endDrag));
        const hlKeys = (e) => {
          hlLiveOk() &&
            (e.key === "ArrowLeft"
              ? (e.preventDefault(), springTo(hlActive - 1))
              : e.key === "ArrowRight"
                ? (e.preventDefault(), springTo(hlActive + 1))
                : e.key === "Home"
                  ? (e.preventDefault(), springTo(0))
                  : e.key === "End" &&
                    (e.preventDefault(), springTo(hlMaxStart)));
        };
        (hlDots.forEach((d, k) => {
          (on(d, "click", () => {
            hlLiveOk() && springTo(k);
          }),
            on(d, "keydown", hlKeys));
        }),
          hlPrev &&
            (on(hlPrev, "click", () => {
              hlLiveOk() && springTo(hlActive - 1);
            }),
            on(hlPrev, "keydown", hlKeys)),
          hlNext &&
            (on(hlNext, "click", () => {
              hlLiveOk() && springTo(hlActive + 1);
            }),
            on(hlNext, "keydown", hlKeys)),
          "ResizeObserver" in window &&
            watch(
              new ResizeObserver(() => {
                const oldStep = Math.max(1, hlStep),
                  wasSpringing = !!hlSpringId,
                  resizeTarget = hlSpringTarget,
                  posIdx =
                    drag || wasSpringing ? hl.scrollLeft / oldStep : hlActive;
                (wasSpringing &&
                  (cancelAnimationFrame(hlSpringId),
                  (hlSpringId = 0),
                  (hlSpringTarget = null)),
                  refreshHlGeometry());
                const nextIdx = Math.max(0, Math.min(hlMaxStart, posIdx));
                if (
                  ((hl.style.scrollSnapType = "none"),
                  (hl.scrollLeft = nextIdx * hlStep),
                  reqVisual(),
                  wasSpringing && !drag)
                ) {
                  springTo(
                    resizeTarget === null ? Math.round(nextIdx) : resizeTarget,
                  );
                  return;
                }
                (hlCommit(Math.round(nextIdx), !0),
                  restoreId && cancelAnimationFrame(restoreId),
                  (restoreId = requestAnimationFrame(() => {
                    ((restoreId = 0),
                      !drag && !hlSpringId && (hl.style.scrollSnapType = ""));
                  })));
              }),
              hl,
            ),
          (hlSetFocusable = (ok) => {
            ((hlControlsFocusable = ok),
              hlDots.concat([hlPrev, hlNext]).forEach((b) => {
                b && (b.tabIndex = ok && !b.hidden ? 0 : -1);
              }));
          }),
          hlSetFocusable(!0),
          writeVisual(),
          hlCommit(Math.round(hl.scrollLeft / hlStep), !0),
          cleanups.push(() => {
            (hlVideos.forEach((video) => {
              video &&
                (video.pause(),
                (video.muted = !0),
                video.removeAttribute("data-hl-should-play"));
            }),
              hlSoundButtons.forEach((soundButton) => {
                soundButton &&
                  (soundButton.removeAttribute("data-sound"),
                  soundButton.setAttribute("aria-pressed", "false"),
                  soundButton.setAttribute(
                    "aria-label",
                    soundButton.dataset.labelOn || "Turn sound on",
                  ),
                  (soundButton.tabIndex = -1));
              }),
              cancelAnimationFrame(pend),
              hlSpringId &&
                (cancelAnimationFrame(hlSpringId), (hlSpringId = 0)),
              (hlSpringTarget = null),
              restoreId && cancelAnimationFrame(restoreId),
              settleT && clearTimeout(settleT),
              (drag = null),
              hl.removeAttribute("data-nh-dragging"),
              (hl.style.scrollSnapType = ""),
              highlightsRoot.style.removeProperty("--nh-beige-progress"));
          }));
      }
      if (
        (cleanups.push(() => {
          (highlightsRoot.removeAttribute("data-hl-live"),
            highlightsRoot.removeAttribute("data-hl-beige"),
            hero.isConnected && hero.setAttribute("data-entrance", "pending"));
        }),
        reduced)
      ) {
        let reducedStoryState = "";
        const syncReducedStory = () => {
          if (dead) return;
          if ((syncTeaserAccess(!1), !responsiveMediaMq.matches)) {
            hero.setAttribute("data-entrance", "reduced");
            const range2 = story.offsetHeight - stage.offsetHeight,
              intro2 =
                range2 <= 2 ||
                Math.max(0, -hero.getBoundingClientRect().top) < range2 - 2,
              nextState2 = intro2 ? "mobile-intro" : "mobile-highlights";
            heroDockMorph && heroDockMorph.render(0);
            if (reducedStoryState === nextState2) return;
            ((reducedStoryState = nextState2),
              hero.toggleAttribute("data-reduced-intro", intro2),
              heroDockMorph && heroDockMorph.jump(!intro2),
              applyCtx(),
              document.dispatchEvent(
                new CustomEvent("hero:reduced-state", { detail: intro2 }),
              ),
              intro2 || publishHighlightsReady());
            return;
          }
          hero.setAttribute("data-entrance", "reduced");
          const range = Math.max(1, story.offsetHeight - stage.offsetHeight),
            y = Math.max(0, -hero.getBoundingClientRect().top),
            intro = y < range * 0.5;
          y >= range * 0.35 && hlPrepareWindow && hlPrepareWindow(0);
          const nextState = intro ? "intro" : "highlights";
          reducedStoryState !== nextState &&
            ((reducedStoryState = nextState),
            hero.toggleAttribute("data-reduced-intro", intro),
            applyCtx(),
            document.dispatchEvent(
              new CustomEvent("hero:reduced-state", { detail: intro }),
            ),
            intro || publishHighlightsReady());
        };
        (on(window, "scroll", syncReducedStory, { passive: !0 }),
          on(window, "resize", syncReducedStory, { passive: !0 }),
          on(window, "load", syncReducedStory, { once: true }),
          on(window, "pageshow", syncReducedStory),
          onMq(responsiveMediaMq, syncReducedStory),
          syncReducedStory(),
          cleanups.push(() => hero.removeAttribute("data-reduced-intro")));
        if ("ResizeObserver" in window) {
          const reducedGeometryObserver = new ResizeObserver(syncReducedStory);
          reducedGeometryObserver.observe(hero);
          reducedGeometryObserver.observe(stage);
          cleanups.push(() => reducedGeometryObserver.disconnect());
        }
      } else {
        hero.setAttribute("data-entrance", "scrub");
        let anims = [];
        const narrativeTracks = new Set([
            "hero-rise",
            "hero-fade-out",
            "hero-shadow-fade",
            "hero-sheet-rise",
            "hero-slide-in",
            "hero-fade-in",
            "hero-highlights-rail-in",
            "hero-highlights-surface-in",
          ]),
          collect = () => {
            ((anims = stage
              .getAnimations({ subtree: !0 })
              .filter(
                (a) =>
                  a instanceof CSSAnimation &&
                  narrativeTracks.has(a.animationName),
              )),
              anims.forEach((a) => a.pause()));
          };
        let target = 0,
          current = null;
        const applyTime = (t) => {
            anims.forEach((a) => { a.currentTime = t; });
            heroDockMorph && heroDockMorph.render(t);
            syncTeaserAccess(!responsiveMediaMq.matches);
            document.dispatchEvent(new CustomEvent("hero:scrub", { detail: t }));
            target >= 1376.35 - 1.5 && t >= 1376.35 - 1.5 && publishHighlightsReady();
          };
        const scrub = () => {
          if (pageLocked()) return;
          anims.length || collect();
          const range = story.offsetHeight - stage.offsetHeight,
            y = -hero.getBoundingClientRect().top;
          // Scroll events already describe the current gesture position.
          // Do not run a trailing animation clock after the gesture stops.
          target = (range > 0 ? Math.min(1, Math.max(0, y / range)) : 0) * 1376.35;
          current = target;
          applyTime(current);
        };
        // An externally opened cart can close anywhere in the hero. Resume
        // that scroll position instead of forcing a dock/focus round-trip.
        heroDockMorph && on(gdabEl, "gdab:close", scrub);
        (on(window, "scroll", scrub, { passive: !0 }),
          on(
            window,
            "resize",
            () => {
              (collect(),
                current !== null && applyTime(current),
                scrub());
            },
            { passive: !0 },
          ),
          on(document, "visibilitychange", () => {
            document.hidden || scrub();
          }));
        const refreshHeroGeometry = () => {
          if (dead) return;
          collect();
          heroDockMorph && heroDockMorph.measure();
          scrub();
        };
        on(window, "load", refreshHeroGeometry, { once: true });
        on(window, "pageshow", refreshHeroGeometry);
        if ("ResizeObserver" in window) {
          const heroGeometryObserver = new ResizeObserver(refreshHeroGeometry);
          watch(heroGeometryObserver, story);
          watch(heroGeometryObserver, stage);
        }
        requestAnimationFrame(() => {
          dead || (collect(), scrub());
        });
      }
    }
    const heroDesktopFilm = document.querySelector("[data-hero-desktop-film]");
    if (heroDesktopFilm) {
      const desktopVideo = heroDesktopFilm.querySelector(
          "[data-hero-desktop-video]",
        ),
        desktopSound = heroDesktopFilm.querySelector(
          "[data-hero-desktop-sound]",
        ),
        desktopPlayback = heroDesktopFilm.querySelector(
          "[data-hero-desktop-playback]",
        );
      if (desktopVideo) {
        const desktopMq = window.matchMedia("(min-width: 1024px)");
        let desktopMode = desktopMq.matches,
          desktopVisible = !0,
          desktopStoryActive = null,
          desktopUserPaused = !1;
        const desktopFrameGate = presentedFrameGate(desktopVideo, () => {
            !desktopMq.matches ||
              !desktopStoryActive ||
              desktopVideo.paused ||
              desktopVideo.readyState < 2 ||
              heroDesktopFilm.classList.add("is-live");
          }),
          desktopResetFrame = () => {
            (desktopFrameGate.cancel(),
              heroDesktopFilm.classList.remove("is-live"));
          },
          desktopSoundReset = () => {
            ((desktopVideo.muted = !0),
              desktopSound &&
                (desktopSound.removeAttribute("data-sound"),
                desktopSound.setAttribute("aria-pressed", "false"),
                desktopSound.setAttribute(
                  "aria-label",
                  desktopSound.dataset.labelOn || "Turn sound on",
                )));
          },
          desktopPlaybackSync = () => {
            desktopPlayback &&
              (desktopPlayback.toggleAttribute(
                "data-paused",
                desktopVideo.paused,
              ),
              desktopPlayback.setAttribute(
                "aria-label",
                desktopVideo.paused
                  ? desktopPlayback.dataset.labelPlay || "Play video"
                  : desktopPlayback.dataset.labelPause || "Pause video",
              ));
          },
          desktopPlay = () => {
            !desktopMq.matches ||
              !desktopVisible ||
              !desktopStoryActive ||
              desktopUserPaused ||
              reduced ||
              (desktopFrameGate.request(), desktopVideo.play().catch(() => {}));
          },
          desktopSyncStory = (active) => {
            active !== desktopStoryActive &&
              ((desktopStoryActive = active),
              heroDesktopFilm.setAttribute(
                "aria-hidden",
                active ? "false" : "true",
              ),
              desktopSound && (desktopSound.disabled = !active),
              desktopPlayback && (desktopPlayback.disabled = !active),
              active
                ? desktopPlay()
                : (desktopVideo.pause(), desktopSoundReset()));
          },
          desktopSyncMode = () => {
            const next = desktopMq.matches;
            if (next === desktopMode) {
              next && desktopPlay();
              return;
            }
            ((desktopMode = next),
              next
                ? (desktopResetFrame(), desktopVideo.load(), desktopPlay())
                : (desktopVideo.pause(), desktopSoundReset()));
          };
        if (
          (on(desktopVideo, "playing", () => {
            (desktopPlaybackSync(),
              desktopFrameGate.request(),
              desktopStoryActive || desktopVideo.pause());
          }),
          on(desktopVideo, "pause", desktopPlaybackSync),
          desktopSound &&
            on(desktopSound, "click", (e) => {
              (e.stopPropagation(),
                desktopStoryActive &&
                  ((desktopVideo.muted = !desktopVideo.muted),
                  desktopSound.toggleAttribute(
                    "data-sound",
                    !desktopVideo.muted,
                  ),
                  desktopSound.setAttribute(
                    "aria-pressed",
                    String(!desktopVideo.muted),
                  ),
                  desktopSound.setAttribute(
                    "aria-label",
                    desktopVideo.muted
                      ? desktopSound.dataset.labelOn || "Turn sound on"
                      : desktopSound.dataset.labelOff || "Turn sound off",
                  ),
                  desktopVideo.paused &&
                    !desktopUserPaused &&
                    (desktopFrameGate.request(),
                    desktopVideo.play().catch(() => {}))));
            }),
          desktopPlayback &&
            on(desktopPlayback, "click", (e) => {
              (e.stopPropagation(),
                desktopStoryActive &&
                  (desktopVideo.paused
                    ? ((desktopUserPaused = !1),
                      desktopFrameGate.request(),
                      desktopVideo.play().catch(() => desktopPlaybackSync()))
                    : ((desktopUserPaused = !0), desktopVideo.pause()),
                  desktopPlaybackSync()));
            }),
          on(document, "hero:scrub", (e) => desktopSyncStory(e.detail < 980)),
          on(document, "hero:reduced-state", (e) =>
            desktopSyncStory(!!e.detail),
          ),
          on(document, "lp:desktop-film-state", (e) => {
            !e.detail ||
              e.detail.film !== heroDesktopFilm ||
              desktopSyncStory(!!e.detail.active);
          }),
          onMq(desktopMq, desktopSyncMode),
          "IntersectionObserver" in window)
        ) {
          const desktopFilmIo = new IntersectionObserver(
            (entries) =>
              entries.forEach((entry) => {
                ((desktopVisible = entry.isIntersecting),
                  desktopVisible ? desktopPlay() : desktopVideo.pause());
              }),
            { rootMargin: "80px" },
          );
          watch(desktopFilmIo, heroDesktopFilm);
        }
        const desktopHeroStory = heroDesktopFilm.closest(".hero"),
          desktopLanderStory = heroDesktopFilm.closest("[data-lp-hero]");
        (desktopSyncStory(
          desktopLanderStory
            ? desktopLanderStory.hasAttribute("data-lp-desktop-film-active")
            : reduced
              ? !desktopHeroStory ||
                desktopHeroStory.hasAttribute("data-reduced-intro")
              : !0,
        ),
          desktopPlaybackSync(),
          requestAnimationFrame(() => {
            dead || desktopSyncMode();
          }),
          cleanups.push(() => {
            (desktopVideo.pause(),
              desktopResetFrame(),
              heroDesktopFilm.removeAttribute("aria-hidden"),
              desktopSound && (desktopSound.disabled = !1),
              desktopPlayback &&
                ((desktopPlayback.disabled = !1),
                desktopPlayback.removeAttribute("data-paused")),
              desktopSoundReset());
          }));
      }
    }
    const theater = document.querySelector(".theater"),
      teaser = document.querySelector(".hero__teaser"),
      stageEl = document.querySelector(".hero__stage");
    if (theater && teaser && stageEl) {
      const theaterMq = window.matchMedia("(max-width: 1023.98px)"),
        frame = theater.querySelector(".theater__frame"),
        media = frame.querySelector("[data-theater-media]"),
        vid = frame.querySelector("video"),
        theaterPoster = frame.querySelector(".theater__poster"),
        soundBtn = theater.querySelector(".theater__sound"),
        homeBtn = theater.querySelector(".theater__back");
      let openState = !1,
        baseRect = null,
        needMeasure = !0,
        lastT = 0,
        filmSleeping = !1,
        openAnimT = 0,
        theaterInert = [],
        theaterLastFocus = null,
        theaterArmed = !1,
        theaterStartT = 0,
        theaterLoadQueued = !1,
        armTheater = () => {},
        disarmTheater = () => {},
        requestTheaterFrame = () => {},
        resetTheaterFrame = () => {};
      const restoreTheaterFocus = () => {
          const prior = theaterLastFocus;
          theaterLastFocus = null;
          const reducedNow = window.matchMedia(
              "(prefers-reduced-motion: reduce)",
            ).matches,
            focusable =
              prior &&
              prior.matches &&
              prior.matches(
                "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])",
              ),
            usable =
              prior &&
              prior.isConnected &&
              prior !== document.body &&
              prior !== document.documentElement &&
              !prior.disabled &&
              !prior.closest("[inert]") &&
              prior.getAttribute("aria-hidden") !== "true" &&
              focusable &&
              !(reducedNow && prior === teaser),
            fallback = document.querySelector(
              "[data-cart-open]:not([disabled]), .site-header__brand[href]",
            ),
            target = usable ? prior : fallback;
          target &&
            typeof target.focus == "function" &&
            target.focus({ preventScroll: !0 });
        },
        easeRise = bez(0.42, 0, 0.58, 1),
        easeFade = bez(0.5, 0, 0.5, 1),
        easeQuint = bez(0.22, 1, 0.36, 1),
        playIcon = frame.querySelector(".theater__play"),
        clipFor = (r) => {
          const radii =
            r.right >= innerWidth - 0.5
              ? "15.13px 0px 0px 15.13px"
              : "15.13px 15.13px 15.13px 15.13px";
          return (
            "inset(" +
            r.top +
            "px " +
            Math.max(0, innerWidth - r.right) +
            "px " +
            Math.max(0, innerHeight - r.bottom) +
            "px " +
            r.left +
            "px round " +
            radii +
            ")"
          );
        },
        measure = () => {
          ((baseRect = {
            top: teaser.offsetTop,
            left: teaser.offsetLeft,
            right: teaser.offsetLeft + teaser.offsetWidth,
            bottom: teaser.offsetTop + teaser.offsetHeight,
          }),
            (needMeasure = !1));
        },
        zoomFor = (eff) => {
          const vw = vid.videoWidth || Number(vid.dataset.videoWidth) || 720,
            vh = vid.videoHeight || Number(vid.dataset.videoHeight) || 1280,
            bw = eff.right - eff.left,
            bh = eff.bottom - eff.top,
            coverFull = Math.max(innerWidth / vw, innerHeight / vh),
            coverT = Math.max(bw / vw, bh / vh);
          return {
            k: coverFull ? coverT / coverFull : 1,
            cx: (eff.left + eff.right) / 2 - innerWidth / 2,
            cy: (eff.top + eff.bottom) / 2 - innerHeight / 2,
          };
        },
        applyZoom = (eff) => {
          if (!eff || !vid || !media || openState) return;
          const z = zoomFor(eff);
          media.style.transform =
            "translate(" + z.cx + "px, " + z.cy + "px) scale(" + z.k + ")";
        },
        effRect = () => {
          const sr = stageEl.getBoundingClientRect();
          return {
            top: baseRect.top + sr.top,
            right: baseRect.right + sr.left,
            bottom: baseRect.bottom + sr.top,
            left: baseRect.left + sr.left,
          };
        },
        ride = (t) => {
          if (
            ((lastT = t),
            !theaterArmed || openState || (needMeasure && measure(), !baseRect))
          )
            return;
          const eff = effRect();
          ((frame.style.clipPath = clipFor(eff)),
            applyZoom(eff),
            playIcon &&
              ((playIcon.style.left = (eff.left + eff.right) / 2 + "px"),
              (playIcon.style.top = (eff.top + eff.bottom) / 2 + "px")));
          const rise =
              -211.81 * easeRise(Math.min(1, Math.max(0, (t - 90) / 1233.45))),
            fade = 1 - easeFade(Math.min(1, Math.max(0, (t - 309.3) / 340.7))),
            gone = fade <= 0.015;
          ((frame.style.transform = "translateY(" + rise + "px)"),
            (theater.style.opacity = fade >= 0.999 ? "" : String(fade)),
            (theater.style.visibility = gone ? "hidden" : ""),
            vid &&
              !reduced &&
              (gone
                ? vid.paused || (vid.pause(), (filmSleeping = !0))
                : filmSleeping &&
                  ((filmSleeping = !1),
                  requestTheaterFrame(),
                  vid.play().catch(() => {}))));
        };
      if (
        (on(document, "hero:scrub", (e) => ride(e.detail)),
        on(
          window,
          "resize",
          () => {
            ((needMeasure = !0), ride(lastT));
          },
          { passive: !0 },
        ),
        vid)
      ) {
        const connection =
            navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection,
          constrainedMedia = !!(
            connection &&
            (connection.saveData ||
              /(^|-)2g$/.test(connection.effectiveType || ""))
          );
        let repeatFilmVisit = !1;
        try {
          repeatFilmVisit = localStorage.getItem("nex:hero-film-seen") === "1";
        } catch {}
        const mobileFrameGate = presentedFrameGate(vid, () => {
          !theaterArmed ||
            !theaterMq.matches ||
            vid.readyState < 2 ||
            (theater.classList.add("has-presented-frame"),
            teaser.classList.add("has-film"));
        });
        ((requestTheaterFrame = mobileFrameGate.request),
          (resetTheaterFrame = () => {
            (mobileFrameGate.cancel(),
              theater.classList.remove("has-presented-frame"));
          }));
        const retireTeaserWhenPosterIsReady = () => {
            if (!theaterPoster) return;
            const retire = () => {
                !dead &&
                  theaterArmed &&
                  theaterMq.matches &&
                  teaser.classList.add("has-film");
              },
              decode = () => {
                typeof theaterPoster.decode == "function"
                  ? theaterPoster.decode().then(retire, retire)
                  : requestAnimationFrame(retire);
              };
            theaterPoster.complete && theaterPoster.naturalWidth > 0
              ? decode()
              : on(theaterPoster, "load", decode, { once: !0 });
          },
          hydrateTheater = () => {
            const src = vid.dataset.srcMobile || "";
            return src
              ? (vid.getAttribute("src") !== src &&
                  (resetTheaterFrame(), (vid.src = src), vid.load()),
                !0)
              : !1;
          },
          playTheater = () => {
            const r = stageEl.getBoundingClientRect(),
              vh = window.visualViewport
                ? window.visualViewport.height
                : window.innerHeight;
            r.bottom <= 0 ||
              r.top >= vh ||
              document.hidden ||
              !theaterArmed ||
              !theaterMq.matches ||
              !hydrateTheater() ||
              (requestTheaterFrame(), vid.play().catch(() => {}));
          },
          queueTheaterStart = () => {
            if (reduced || constrainedMedia || theaterLoadQueued) return;
            theaterLoadQueued = !0;
            const queue = () => {
              dead ||
                !theaterArmed ||
                !theaterMq.matches ||
                (theaterStartT = setTimeout(
                  playTheater,
                  repeatFilmVisit ? 100 : 2200,
                ));
            };
            document.readyState === "complete"
              ? queue()
              : on(window, "load", queue, { once: !0 });
          };
        if (
          (on(vid, "playing", () => {
            (requestTheaterFrame(), (repeatFilmVisit = !0));
            try {
              localStorage.setItem("nex:hero-film-seen", "1");
            } catch {}
          }),
          (armTheater = (reload = !0) => {
            theaterArmed ||
              !theaterMq.matches ||
              ((theaterArmed = !0),
              ride(lastT),
              theater.classList.add("is-live"),
              retireTeaserWhenPosterIsReady(),
              queueTheaterStart(),
              requestAnimationFrame(() => {
                dead || ride(lastT);
              }));
          }),
          (disarmTheater = () => {
            theaterArmed &&
              ((theaterArmed = !1),
              clearTimeout(theaterStartT),
              (theaterStartT = 0),
              (theaterLoadQueued = !1),
              vid.pause(),
              (vid.muted = !0),
              resetTheaterFrame(),
              theater.classList.remove("is-live"),
              teaser.classList.remove("has-film"),
              theater.style.removeProperty("opacity"),
              theater.style.removeProperty("visibility"),
              theaterMq.matches || (vid.removeAttribute("src"), vid.load()));
          }),
          on(vid, "loadedmetadata", () => {
            baseRect && !openState && theaterArmed && applyZoom(effRect());
          }),
          theaterMq.matches && armTheater(!1),
          cleanups.push(disarmTheater),
          "IntersectionObserver" in window)
        ) {
          const tio = new IntersectionObserver(
            (es) =>
              es.forEach((en) => {
                openState ||
                  !theaterArmed ||
                  (en.isIntersecting
                    ? ride(lastT)
                    : vid.paused || (vid.pause(), (filmSleeping = !0)));
              }),
            { rootMargin: "80px" },
          );
          watch(tio, stageEl);
        }
      }
      const open = () => {
        if (openState || !vid || !theaterArmed || !theaterMq.matches) return;
        const mobileSrc = vid.dataset.srcMobile || "";
        (mobileSrc &&
          vid.getAttribute("src") !== mobileSrc &&
          (resetTheaterFrame(), (vid.src = mobileSrc), vid.load()),
          (openState = !0),
          (theater.style.opacity = "1"),
          (theater.style.visibility = ""),
          theater.classList.add("is-animating", "is-open"),
          theater.setAttribute("aria-hidden", "false"),
          (filmSleeping = !1),
          requestTheaterFrame(),
          vid.play().catch(() => {}),
          (frame.style.transform = "none"),
          media && (media.style.transform = "none"),
          (frame.style.clipPath =
            "inset(0px 0px 0px 0px round 0px 0px 0px 0px)"),
          lockScroll(),
          (theaterLastFocus = document.activeElement),
          (theaterInert = inertOutside(theater, [])),
          theater.focus({ preventScroll: !0 }),
          clearTimeout(openAnimT),
          (openAnimT = setTimeout(
            () => theater.classList.remove("is-animating"),
            640,
          )));
      };
      let closing = !1;
      const close = () => {
        if (!openState || !vid || closing) return;
        ((closing = !0),
          clearTimeout(openAnimT),
          theater.classList.add("is-closing"),
          theater.classList.remove("is-open", "is-animating"));
        const eff = baseRect ? effRect() : null,
          B_MS = 520,
          boxB = eff
            ? {
                top: eff.top,
                right: Math.max(0, innerWidth - eff.right),
                bottom: Math.max(0, innerHeight - eff.bottom),
                left: eff.left,
                r:
                  eff.right >= innerWidth - 0.5
                    ? [15.13, 0, 0, 15.13]
                    : [15.13, 15.13, 15.13, 15.13],
              }
            : { top: 0, right: 0, bottom: 0, left: 0, r: [0, 0, 0, 0] },
          zoom = eff ? zoomFor(eff) : null,
          emit = (b) => {
            frame.style.clipPath =
              "inset(" +
              b.top +
              "px " +
              b.right +
              "px " +
              b.bottom +
              "px " +
              b.left +
              "px round " +
              b.r[0] +
              "px " +
              b.r[1] +
              "px " +
              b.r[2] +
              "px " +
              b.r[3] +
              "px)";
          },
          mix = (from, to, e) => ({
            top: from.top + (to.top - from.top) * e,
            right: from.right + (to.right - from.right) * e,
            bottom: from.bottom + (to.bottom - from.bottom) * e,
            left: from.left + (to.left - from.left) * e,
            r: from.r.map((v, i) => v + (to.r[i] - v) * e),
          });
        let done = !1;
        const finish = () => {
            done ||
              ((done = !0),
              clearTimeout(safety),
              theater.classList.remove("is-closing", "is-animating"),
              unlockScroll(),
              inertRestore(theaterInert),
              (theaterInert = []),
              (vid.muted = !0),
              soundBtn &&
                (soundBtn.removeAttribute("data-sound"),
                soundBtn.setAttribute("aria-pressed", "false"),
                soundBtn.setAttribute(
                  "aria-label",
                  soundBtn.dataset.labelOn || "Turn sound on",
                )),
              reduced && !vid.paused && vid.pause(),
              (openState = !1),
              (closing = !1),
              restoreTheaterFocus(),
              theater.setAttribute("aria-hidden", "true"),
              theaterMq.matches ? ride(lastT) : disarmTheater());
          },
          safety = setTimeout(finish, B_MS + 400);
        if (reduced) {
          finish();
          return;
        }
        const zero = { top: 0, right: 0, bottom: 0, left: 0, r: [0, 0, 0, 0] };
        let startT = 0;
        const step = (now) => {
          if (done || dead) return;
          startT || (startT = now);
          const t = now - startT;
          if (t < B_MS) {
            const e = easeQuint(t / B_MS);
            (emit(mix(zero, boxB, e)),
              zoom &&
                media &&
                (media.style.transform =
                  "translate(" +
                  zoom.cx * e +
                  "px, " +
                  zoom.cy * e +
                  "px) scale(" +
                  (1 + (zoom.k - 1) * e) +
                  ")"));
          } else {
            finish();
            return;
          }
          requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      (onMq(theaterMq, (e) => {
        e.matches ? armTheater() : openState ? close() : disarmTheater();
      }),
        on(teaser, "click", open),
        homeBtn && on(homeBtn, "click", close),
        soundBtn &&
          vid &&
          on(soundBtn, "click", () => {
            ((vid.muted = !vid.muted),
              soundBtn.toggleAttribute("data-sound", !vid.muted),
              soundBtn.setAttribute("aria-pressed", String(!vid.muted)),
              soundBtn.setAttribute(
                "aria-label",
                vid.muted
                  ? soundBtn.dataset.labelOn || "Turn sound on"
                  : soundBtn.dataset.labelOff || "Turn sound off",
              ));
          }),
        on(document, "keydown", (e) => {
          if (openState) {
            if (e.key === "Escape") {
              close();
              return;
            }
            if (e.key === "Tab") {
              const items = [soundBtn, homeBtn].filter((b) => b && !b.disabled);
              if (!items.length) return;
              const first = items[0],
                last = items[items.length - 1],
                ae = document.activeElement;
              !theater.contains(ae) || ae === theater
                ? ((e.shiftKey ? last : first).focus(), e.preventDefault())
                : e.shiftKey && ae === first
                  ? (last.focus(), e.preventDefault())
                  : !e.shiftKey &&
                    ae === last &&
                    (first.focus(), e.preventDefault());
            }
          }
        }),
        cleanups.push(() => {
          (clearTimeout(openAnimT),
            (openState || closing) &&
              (theater.classList.remove(
                "is-open",
                "is-animating",
                "is-closing",
              ),
              inertRestore(theaterInert),
              (theaterInert = []),
              restoreTheaterFocus(),
              theater.setAttribute("aria-hidden", "true"),
              vid && ((vid.muted = !0), vid.pause()),
              (openState = !1),
              (closing = !1)));
        }));
    }
    const dmRoot = document.querySelector("[data-dm]");
    if (dmRoot) {
      const dmNav = dmRoot.querySelector("[data-dm-nav]"),
        dmPills = [...dmRoot.querySelectorAll("[data-dm-pill]")],
        dmClose = dmRoot.querySelector("[data-dm-close]"),
        dmVideo = dmRoot.querySelector("[data-dm-video]"),
        dmFilm = dmRoot.querySelector("[data-dm-film]"),
        dmPrev = dmRoot.querySelector("[data-dm-prev]"),
        dmNext = dmRoot.querySelector("[data-dm-next]"),
        dmExpand = dmRoot.querySelector("[data-dm-expand]"),
        dmCollapseBtn = dmRoot.querySelector("[data-dm-collapse]"),
        dmVideoTemplates = [
          ...dmRoot.querySelectorAll("[data-dm-video-template]"),
        ],
        dmVideoTemplateByIndex = new Map(
          dmVideoTemplates
            .map((template) => [Number(template.dataset.dmFor), template])
            .filter(([index]) => Number.isFinite(index)),
        );
      let dmLoadedVideoIndex = dmVideo ? Number(dmVideo.dataset.dmFor) : -1,
        dmVideoSwapFrame = 0;
      const dmHasVideoIndex = (index) =>
          dmVideoTemplateByIndex.has(Number(index)),
        dmLoadVideoIndex = (index, visualSwap = !1) => {
          const nextIndex = Number(index),
            template = dmVideoTemplateByIndex.get(nextIndex);
          if (!dmVideo || !dmFilm || !template) return !1;
          const nextStyle = template.dataset.dmStyle || "framed";
          if (
            dmLoadedVideoIndex === nextIndex &&
            dmVideo.dataset.dmFor === String(nextIndex)
          )
            return ((dmVideo.dataset.dmStyle = nextStyle), !0);
          (visualSwap && dmVideo.setAttribute("data-dm-swapping", ""),
            (dmVideo.dataset.dmStyle = nextStyle),
            cancelAnimationFrame(dmVideoSwapFrame),
            dmFilm.pause());
          try {
            dmFilm.currentTime = 0;
          } catch {}
          (dmFilm.removeAttribute("src"),
            dmFilm.replaceChildren(),
            dmFilm.removeAttribute("poster"),
            dmFilm.removeAttribute("data-poster-mobile"),
            dmFilm.removeAttribute("data-poster-desktop"),
            dmFilm.removeAttribute("data-dm-metadata-prepared"),
            dmFilm.removeAttribute("data-dm-metadata-failed"),
            (dmFilm.preload = "none"),
            dmFilm.load());
          const posterMobile = template.dataset.posterMobile || "",
            posterDesktop = template.dataset.posterDesktop || posterMobile;
          (posterMobile && (dmFilm.dataset.posterMobile = posterMobile),
            posterDesktop && (dmFilm.dataset.posterDesktop = posterDesktop),
            dmFilm.setAttribute("data-poster-defer", ""),
            dmFilm.replaceChildren(template.content.cloneNode(!0)),
            (dmLoadedVideoIndex = nextIndex),
            (dmVideo.dataset.dmFor = String(nextIndex)));
          const collapsedTop =
            dmPills[nextIndex] &&
            dmPills[nextIndex].style.getPropertyValue("--dm-vc-top");
          return (
            collapsedTop &&
              dmRoot.style.setProperty("--dm-vc-top", collapsedTop),
            visualSwap &&
              (dmVideoSwapFrame = requestAnimationFrame(() => {
                !dead &&
                  dmLoadedVideoIndex === nextIndex &&
                  dmVideo.removeAttribute("data-dm-swapping");
              })),
            !0
          );
        },
        dmDesktop = window.matchMedia("(min-width: 1024px)"),
        dmIsHomeDesktop = () =>
          dmRoot.classList.contains("dm--home") && dmDesktop.matches,
        dmRailTop = () => (dmDesktop.matches ? 200 : 568),
        RAIL_PAD = 20,
        PILL_GAP = 17.5,
        dmConnection =
          navigator.connection ||
          navigator.mozConnection ||
          navigator.webkitConnection,
        dmConstrained = () =>
          !!(
            dmConnection &&
            (dmConnection.saveData ||
              /^(slow-2g|2g)$/.test(dmConnection.effectiveType || ""))
          ),
        dmPrepareMetadata = (speculative = !1) => {
          if (dmFilm && !(speculative && dmConstrained())) {
            if (dmFilm.dataset.dmMetadataPrepared === "true") {
              !speculative &&
                dmFilm.dataset.dmMetadataFailed === "true" &&
                (delete dmFilm.dataset.dmMetadataFailed, dmFilm.load());
              return;
            }
            (dmFilm.hasAttribute("data-poster-defer") &&
              (dmFilm.removeAttribute("data-poster-defer"),
              syncNativePoster(dmFilm)),
              dmFilm.querySelectorAll("source[data-src]").forEach((source) => {
                (source.dataset.src && (source.src = source.dataset.src),
                  source.removeAttribute("data-src"));
              }),
              (dmFilm.dataset.dmMetadataPrepared = "true"),
              (dmFilm.preload = "metadata"),
              dmFilm.paused && dmFilm.load());
          }
        };
      if (dmFilm) {
        if (
          (on(dmFilm, "error", () => {
            dmFilm.dataset.dmMetadataPrepared === "true" &&
              (dmFilm.dataset.dmMetadataFailed = "true");
          }),
          on(dmFilm, "loadedmetadata", () => {
            delete dmFilm.dataset.dmMetadataFailed;
          }),
          "IntersectionObserver" in window)
        ) {
          const dmVideoIo = new IntersectionObserver(
            (entries) => {
              entries.some((entry) => entry.isIntersecting) &&
                (dmPrepareMetadata(!0),
                dmFilm.dataset.dmMetadataPrepared === "true" &&
                  dmVideoIo.disconnect());
            },
            { rootMargin: "25% 0px", threshold: 0 },
          );
          watch(dmVideoIo, dmRoot);
        }
        const dmVideoTrigger =
          dmPills[dmLoadedVideoIndex] &&
          dmPills[dmLoadedVideoIndex].querySelector("[data-dm-hit]");
        dmVideoTrigger &&
          (on(dmVideoTrigger, "pointerenter", () => dmPrepareMetadata(!0)),
          on(dmVideoTrigger, "focus", () => dmPrepareMetadata(!0)),
          on(dmVideoTrigger, "touchstart", () => dmPrepareMetadata(!0), {
            passive: !0,
          }));
      }
      dmRoot.dataset.open === void 0 && (dmRoot.dataset.open = "");
      const dmSyncPaddles = (index) => {
          (dmPrev && (dmPrev.disabled = index <= 0),
            dmNext &&
              (dmNext.disabled = index < 0 || index >= dmPills.length - 1));
        },
        dmSetButtonAccess = (button, enabled) => {
          button &&
            ((button.disabled = !enabled),
            (button.tabIndex = enabled ? 0 : -1),
            enabled
              ? button.removeAttribute("aria-hidden")
              : button.setAttribute("aria-hidden", "true"));
        },
        dmSyncMediaAccess = () => {
          const mediaState = dmRoot.dataset.media || "",
            mobileMedia = !dmIsHomeDesktop();
          (dmSetButtonAccess(
            dmExpand,
            mobileMedia && mediaState === "collapsed",
          ),
            dmSetButtonAccess(
              dmCollapseBtn,
              mobileMedia && mediaState === "playing",
            ));
        },
        dmSyncPanelAccess = (index, moveFocus = !1) => {
          (dmPills.forEach((pill, i) => {
            const hit = pill.querySelector("[data-dm-hit]"),
              panel = pill.querySelector("[data-dm-panel]"),
              active = i === index;
            if (
              (panel &&
                (panel.setAttribute("aria-hidden", String(!active)),
                panel.toggleAttribute("inert", !active),
                (panel.tabIndex = -1)),
              hit)
            ) {
              const role = pill.dataset.role || "",
                reachable =
                  index === -1
                    ? !0
                    : dmIsHomeDesktop()
                      ? !active
                      : role === "prev" || role === "next";
              dmSetButtonAccess(hit, reachable);
            }
            active &&
              moveFocus &&
              panel &&
              requestAnimationFrame(() => {
                !dead &&
                  dmRoot.dataset.open === String(index) &&
                  panel.focus({ preventScroll: !0 });
              });
          }),
            dmSetButtonAccess(dmClose, index !== -1),
            dmSyncPaddles(index));
        };
      (dmSyncPanelAccess(-1), dmSyncMediaAccess());
      const dmMediaAccessMo = new MutationObserver(dmSyncMediaAccess);
      (dmMediaAccessMo.observe(dmRoot, {
        attributes: !0,
        attributeFilter: ["data-media"],
      }),
        cleanups.push(() => dmMediaAccessMo.disconnect()));
      const dmFit = () => {
        const w = dmRoot.clientWidth;
        if (!w) return;
        if (dmDesktop.matches) {
          (dmRoot.style.setProperty("--dm-s", 1),
            dmRoot.style.setProperty("--dm-x", "0px"));
          return;
        }
        const s = Math.min(w / 402, window.matchMedia("(min-width: 600px)").matches ? 1.8 : 1.15);
        (dmRoot.style.setProperty("--dm-s", s),
          dmRoot.style.setProperty(
            "--dm-x",
            `${Math.max(0, (w - 402 * s) / 2)}px`,
          ));
      };
      if ((dmFit(), "ResizeObserver" in window)) {
        const dmRo = new ResizeObserver(dmFit);
        watch(dmRo, dmRoot);
      } else on(window, "resize", dmFit, { passive: !0 });
      const dmCompactLeft = [],
        dmLayoutRail = () => {
          dmRoot.dataset.measuring = "1";
          const compactWidths = dmPills.map((pill) => {
              const text = pill.querySelector(".dm__compact-text");
              return Math.ceil(61 + (text ? text.offsetWidth : 55));
            }),
            peekPadding =
              !dmDesktop.matches && compactWidths.length >= 3
                ? Math.max(
                    0,
                    (dmNav.clientWidth - RAIL_PAD - 2 * PILL_GAP -
                      compactWidths[0] - compactWidths[1] - compactWidths[2] / 2) / 2.5,
                  )
                : 0;
          let x = RAIL_PAD;
          (dmPills.forEach((pill, i) => {
            const text = pill.querySelector(".dm__compact-text"),
              w = compactWidths[i] + peekPadding,
              desktopW = Math.ceil(76 + (text ? text.offsetWidth : 55));
            ((dmCompactLeft[i] = x),
              pill.style.setProperty("--dm-pl", `${x}px`),
              pill.style.setProperty("--dm-pw", `${w}px`),
              pill.style.setProperty("--dm-desktop-compact-w", `${desktopW}px`),
              (x += w + PILL_GAP));
          }),
            dmRoot.style.setProperty(
              "--dm-track-w",
              `${x - PILL_GAP + RAIL_PAD}px`,
            ),
            dmRoot.offsetWidth,
            delete dmRoot.dataset.measuring);
        },
        dmMeasurePanels = () => {
          dmPills.forEach((pill) => {
            const panel = pill.querySelector("[data-dm-panel]");
            if (!panel) return;
            const dims = panel.querySelector("[data-dm-dims]");
            if (dims) {
              let dh = 150;
              (dims.querySelectorAll(".dm__dim").forEach((img) => {
                const r =
                  (img.naturalWidth ||
                    Number(img.getAttribute("width")) ||
                    804) /
                  (img.naturalHeight ||
                    Number(img.getAttribute("height")) ||
                    628);
                dh = Math.max(dh, 270.724 / r);
              }),
                dmRoot.style.setProperty("--dm-dims-h", `${Math.ceil(dh)}px`));
            }
            const h = Math.ceil(panel.offsetHeight) + 16;
            (pill.style.setProperty("--dm-panel-h", `${h}px`),
              pill.style.setProperty("--dm-panel-top", `${-(h - 52)}px`));
            const pillIndex = Number(pill.dataset.index);
            if (dmHasVideoIndex(pillIndex)) {
              const collapsedTop = `${dmRailTop() - (h - 52) - 27.85}px`;
              (pill.style.setProperty("--dm-vc-top", collapsedTop),
                pillIndex === dmLoadedVideoIndex &&
                  dmRoot.style.setProperty("--dm-vc-top", collapsedTop));
            }
            if (dmIsHomeDesktop()) {
              const desktopWidth = dmNav.clientWidth;
              desktopWidth && (panel.style.width = `${desktopWidth}px`);
              const desktopEndSpace = panel.querySelector(
                  ".dm__fine, .dm__copy",
                )
                  ? 26
                  : 0,
                desktopH = Math.max(
                  160,
                  Math.ceil(panel.scrollHeight + desktopEndSpace),
                );
              (panel.style.removeProperty("width"),
                pill.style.setProperty(
                  "--dm-desktop-panel-h",
                  `${desktopH}px`,
                ));
            }
          });
        };
      let dmMeasuredNavW = -1;
      const dmRelayout = () => {
        (dmLayoutRail(),
          dmMeasurePanels(),
          (dmMeasuredNavW = dmNav.clientWidth));
      };
      if ((dmRelayout(), "ResizeObserver" in window)) {
        const dmMeasureRo = new ResizeObserver((entries) => {
          const w = entries[0]
            ? entries[0].contentRect.width
            : dmNav.clientWidth;
          Math.abs(w - dmMeasuredNavW) < 0.5 || dmRelayout();
        });
        watch(dmMeasureRo, dmNav);
      }
      (document.fonts &&
        document.fonts.ready &&
        document.fonts.ready.then(dmRelayout),
        dmRoot.querySelectorAll(".dm__dim").forEach((img) => {
          on(img, "load", dmRelayout);
        }));
      const DM_PANEL_MS = reduced ? 1 : 540,
        DM_VIDEO_MS = reduced ? 1 : 550,
        DM_CLOSE_MS = reduced ? 1 : 550;
      let dmPanelT = 0,
        dmPlayT = 0,
        dmCollapseT = 0,
        dmClosingT = 0,
        dmSavedScroll = 0;
      cleanups.push(() => {
        const priorIndex =
            dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open),
          restoreFocus =
            priorIndex >= 0 && dmRoot.contains(document.activeElement);
        if (
          (clearTimeout(dmPanelT),
          clearTimeout(dmPlayT),
          clearTimeout(dmCollapseT),
          clearTimeout(dmClosingT),
          cancelAnimationFrame(dmVideoSwapFrame),
          dmVideo && dmVideo.removeAttribute("data-dm-swapping"),
          (dmRoot.dataset.open = ""),
          (dmRoot.dataset.media = ""),
          dmRoot.removeAttribute("data-kind"),
          dmRoot.removeAttribute("data-closing"),
          dmRoot.removeAttribute("data-restoring-rail"),
          (dmNav.scrollLeft = 0),
          dmPills.forEach((pill) => {
            (pill.removeAttribute("data-role"),
              pill.style.removeProperty("left"),
              pill.style.removeProperty("top"),
              pill.style.removeProperty("width"),
              pill.style.removeProperty("height"));
            const hit = pill.querySelector("[data-dm-hit]");
            hit && hit.setAttribute("aria-expanded", "false");
          }),
          dmRoot.querySelectorAll("[data-dm-art]").forEach((layer) => {
            (layer.classList.remove("is-active"),
              layer.setAttribute("aria-hidden", "true"));
          }),
          dmFilm && dmFilm.pause(),
          dmSyncPanelAccess(-1),
          restoreFocus)
        ) {
          const hit =
            dmPills[priorIndex] &&
            dmPills[priorIndex].querySelector("[data-dm-hit]");
          hit && hit.isConnected && hit.focus({ preventScroll: !0 });
        }
      });
      const dmStartMedia = () => {
          (clearTimeout(dmPlayT),
            clearTimeout(dmCollapseT),
            dmPrepareMetadata(!1),
            (dmRoot.dataset.media = "expanding"),
            dmFilm && dmFilm.play().catch(() => {}),
            (dmPlayT = setTimeout(() => {
              dmRoot.dataset.media = "playing";
            }, DM_VIDEO_MS)));
        },
        dmBeginPanel = () => {
          ((dmRoot.dataset.media = "panel-entering"),
            (dmPanelT = setTimeout(dmStartMedia, DM_PANEL_MS)));
        },
        dmSetDetailDesktop = (next) => {
          const current =
            dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open);
          if (next === current) return;
          const nextIsVideo = dmHasVideoIndex(next),
            videoToVideo = dmHasVideoIndex(current) && nextIsVideo;
          if (
            (clearTimeout(dmPlayT),
            clearTimeout(dmCollapseT),
            clearTimeout(dmPanelT),
            clearTimeout(dmClosingT),
            nextIsVideo &&
              (dmLoadVideoIndex(next, videoToVideo), dmPrepareMetadata(!1)),
            dmRoot.removeAttribute("data-closing"),
            dmRoot.removeAttribute("data-restoring-rail"),
            (dmNav.scrollLeft = 0),
            dmPills.forEach((pill) => {
              (pill.style.removeProperty("left"),
                pill.style.removeProperty("top"),
                pill.style.removeProperty("width"),
                pill.style.removeProperty("height"));
            }),
            (dmRoot.dataset.open = next === -1 ? "" : String(next)),
            next === -1
              ? dmRoot.removeAttribute("data-kind")
              : (dmRoot.dataset.kind = dmPills[next].dataset.kind),
            (dmRoot.dataset.media = nextIsVideo ? "playing" : ""),
            dmPills.forEach((pill, i) => {
              const hit = pill.querySelector("[data-dm-hit]");
              (hit && hit.setAttribute("aria-expanded", String(i === next)),
                i === next
                  ? (pill.dataset.role = "active")
                  : pill.removeAttribute("data-role"));
            }),
            dmRoot.querySelectorAll("[data-dm-art]").forEach((layer) => {
              const active = Number(layer.dataset.dmArt) === next;
              (layer.classList.toggle("is-active", active),
                layer.setAttribute("aria-hidden", String(!active)));
            }),
            dmSyncPanelAccess(next, next !== -1),
            dmFilm &&
              (nextIsVideo && !reduced
                ? dmFilm.play().catch(() => {})
                : dmFilm.pause()),
            next === -1 && current >= 0)
          ) {
            const restoreHit =
              dmPills[current] &&
              dmPills[current].querySelector("[data-dm-hit]");
            !dead &&
              restoreHit &&
              dmRoot.dataset.open === "" &&
              restoreHit.focus({ preventScroll: !0 });
          }
        },
        dmSetDetail = (next) => {
          if (dmIsHomeDesktop()) {
            dmSetDetailDesktop(next);
            return;
          }
          const current =
            dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open);
          if (next === current) return;
          const nextIsVideo = dmHasVideoIndex(next),
            videoToVideo = dmHasVideoIndex(current) && nextIsVideo;
          if (
            (dmRoot.removeAttribute("data-restoring-rail"),
            clearTimeout(dmPlayT),
            clearTimeout(dmCollapseT),
            clearTimeout(dmPanelT),
            clearTimeout(dmClosingT),
            dmRoot.removeAttribute("data-closing"),
            nextIsVideo
              ? (dmLoadVideoIndex(next, videoToVideo), dmPrepareMetadata(!1))
              : dmFilm && dmFilm.pause(),
            nextIsVideo && dmVideo)
          ) {
            const st = getComputedStyle(dmPills[next]);
            (dmRoot.style.setProperty(
              "--dm-vsrc-l",
              `${parseFloat(st.left) - dmNav.scrollLeft}px`,
            ),
              dmRoot.style.setProperty(
                "--dm-vsrc-t",
                `${dmRailTop() + parseFloat(st.top)}px`,
              ),
              dmRoot.style.setProperty("--dm-vsrc-w", st.width),
              dmRoot.style.setProperty("--dm-vsrc-h", st.height),
              dmRoot.offsetWidth);
          }
          if (
            (current === -1 &&
              next !== -1 &&
              ((dmSavedScroll = dmNav.scrollLeft),
              dmPills.forEach((pill) => {
                const st = getComputedStyle(pill);
                ((pill.style.left = `${parseFloat(st.left) - dmSavedScroll}px`),
                  (pill.style.top = st.top),
                  (pill.style.width = st.width),
                  (pill.style.height = st.height));
              }),
              (dmNav.style.scrollBehavior = "auto"),
              (dmNav.scrollLeft = 0),
              dmNav.offsetWidth,
              dmNav.style.removeProperty("scroll-behavior")),
            current !== -1 && next === -1 && (dmRoot.dataset.closing = "true"),
            (dmRoot.dataset.open = next === -1 ? "" : String(next)),
            next === -1
              ? dmRoot.removeAttribute("data-kind")
              : (dmRoot.dataset.kind = dmPills[next].dataset.kind),
            (dmRoot.dataset.media = nextIsVideo ? "panel-waiting" : ""),
            dmPills.forEach((pill, i) => {
              const hit = pill.querySelector("[data-dm-hit]");
              if (
                (hit && hit.setAttribute("aria-expanded", String(i === next)),
                next === -1)
              ) {
                pill.removeAttribute("data-role");
                return;
              }
              pill.dataset.role =
                i === next
                  ? "active"
                  : i === next - 1
                    ? "prev"
                    : i === next + 1
                      ? "next"
                      : i < next
                        ? "hidden-left"
                        : "hidden-right";
            }),
            dmRoot.querySelectorAll("[data-dm-art]").forEach((layer) => {
              const active = Number(layer.dataset.dmArt) === next;
              (layer.classList.toggle("is-active", active),
                layer.setAttribute("aria-hidden", String(!active)));
            }),
            dmSyncPanelAccess(next, next !== -1),
            current === -1 && next !== -1
              ? requestAnimationFrame(() => {
                  (dmPills.forEach((pill) => {
                    (pill.style.removeProperty("left"),
                      pill.style.removeProperty("top"),
                      pill.style.removeProperty("width"),
                      pill.style.removeProperty("height"));
                  }),
                    nextIsVideo && dmBeginPanel());
                })
              : nextIsVideo && dmBeginPanel(),
            next === -1 && current !== -1)
          ) {
            const restoreHit =
              dmPills[current] &&
              dmPills[current].querySelector("[data-dm-hit]");
            (!dead &&
              restoreHit &&
              dmRoot.dataset.open === "" &&
              restoreHit.focus({ preventScroll: !0 }),
              dmPills.forEach((pill, i) => {
                pill.style.left = `${dmCompactLeft[i] - dmSavedScroll}px`;
              }),
              (dmClosingT = setTimeout(() => {
                ((dmNav.style.scrollBehavior = "auto"),
                  (dmRoot.dataset.restoringRail = "true"),
                  dmRoot.removeAttribute("data-closing"),
                  dmNav.offsetWidth,
                  (dmNav.scrollLeft = Math.min(
                    dmSavedScroll,
                    Math.max(0, dmNav.scrollWidth - dmNav.clientWidth),
                  )),
                  dmPills.forEach((pill) => pill.style.removeProperty("left")),
                  dmNav.offsetWidth,
                  dmNav.style.removeProperty("scroll-behavior"),
                  dmRoot.removeAttribute("data-restoring-rail"));
              }, DM_CLOSE_MS)));
          }
        },
        dmIsHome = dmRoot.classList.contains("dm--home");
      let dmSwipeStart = null;
      (on(
        dmRoot,
        "touchstart",
        (e) => {
          if (
            ((dmSwipeStart = null),
            !dmIsHome ||
              dmDesktop.matches ||
              dmRoot.dataset.open === "" ||
              e.touches.length !== 1)
          )
            return;
          const target = e.target;
          if (
            target &&
            target.closest &&
            target.closest(
              "button, a, input, textarea, select, video, [data-dm-swatch], [data-dm-seg], [data-dm-video]",
            )
          )
            return;
          const touch = e.touches[0];
          dmSwipeStart = {
            x: touch.clientX,
            y: touch.clientY,
            at: performance.now(),
          };
        },
        { passive: !0 },
      ),
        on(
          dmRoot,
          "touchend",
          (e) => {
            const start2 = dmSwipeStart;
            if (
              ((dmSwipeStart = null),
              !start2 || dmDesktop.matches || !e.changedTouches.length)
            )
              return;
            const touch = e.changedTouches[0],
              dx = touch.clientX - start2.x,
              dy = touch.clientY - start2.y;
            if (
              performance.now() - start2.at > 700 ||
              Math.abs(dx) < 44 ||
              Math.abs(dx) <= Math.abs(dy) * 1.2
            )
              return;
            const current =
              dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open);
            if (current < 0) return;
            const next = current + (dx < 0 ? 1 : -1);
            next >= 0 && next < dmPills.length && dmSetDetail(next);
          },
          { passive: !0 },
        ),
        on(
          dmRoot,
          "touchcancel",
          () => {
            dmSwipeStart = null;
          },
          { passive: !0 },
        ),
        dmPills.forEach((pill, i) => {
          const hit = pill.querySelector("[data-dm-hit]");
          hit && on(hit, "click", () => dmSetDetail(i));
        }),
        on(dmClose, "click", () => dmSetDetail(-1)),
        dmPrev &&
          on(dmPrev, "click", () => {
            const current =
              dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open);
            current > 0 && dmSetDetail(current - 1);
          }),
        dmNext &&
          on(dmNext, "click", () => {
            const current =
              dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open);
            current >= 0 &&
              current < dmPills.length - 1 &&
              dmSetDetail(current + 1);
          }));
      let dmWasDesktop = dmDesktop.matches;
      (onMq(dmDesktop, () => {
        const isDesktop = dmDesktop.matches;
        if (isDesktop === dmWasDesktop) return;
        dmWasDesktop = isDesktop;
        const priorIndex =
            dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open),
          restoreFocus =
            priorIndex >= 0 && dmRoot.contains(document.activeElement);
        if (
          (clearTimeout(dmPlayT),
          clearTimeout(dmCollapseT),
          clearTimeout(dmPanelT),
          clearTimeout(dmClosingT),
          cancelAnimationFrame(dmVideoSwapFrame),
          dmVideo && dmVideo.removeAttribute("data-dm-swapping"),
          (dmRoot.dataset.open = ""),
          (dmRoot.dataset.media = ""),
          dmRoot.removeAttribute("data-kind"),
          dmRoot.removeAttribute("data-closing"),
          dmRoot.removeAttribute("data-restoring-rail"),
          (dmNav.scrollLeft = 0),
          dmPills.forEach((pill) => {
            (pill.removeAttribute("data-role"),
              pill.style.removeProperty("left"),
              pill.style.removeProperty("top"),
              pill.style.removeProperty("width"),
              pill.style.removeProperty("height"));
            const hit = pill.querySelector("[data-dm-hit]");
            hit && hit.setAttribute("aria-expanded", "false");
          }),
          dmRoot.querySelectorAll("[data-dm-art]").forEach((layer) => {
            (layer.classList.remove("is-active"),
              layer.setAttribute("aria-hidden", "true"));
          }),
          dmFilm && dmFilm.pause(),
          dmSyncPanelAccess(-1),
          restoreFocus)
        ) {
          const hit =
            dmPills[priorIndex] &&
            dmPills[priorIndex].querySelector("[data-dm-hit]");
          hit && hit.isConnected && hit.focus({ preventScroll: !0 });
        }
        requestAnimationFrame(dmRelayout);
      }),
        dmExpand &&
          on(dmExpand, "click", (e) => {
            (e.stopPropagation(),
              dmRoot.dataset.media === "collapsed" && dmStartMedia());
          }),
        dmCollapseBtn &&
          on(dmCollapseBtn, "click", (e) => {
            (e.stopPropagation(),
              dmRoot.dataset.media === "playing" &&
                (clearTimeout(dmPlayT),
                clearTimeout(dmCollapseT),
                (dmRoot.dataset.media = "collapsing"),
                dmFilm && dmFilm.pause(),
                (dmCollapseT = setTimeout(() => {
                  dmRoot.dataset.media = "collapsed";
                }, DM_VIDEO_MS))));
          }),
        dmRoot.querySelectorAll("[data-dm-swatch]").forEach((btn) => {
          on(btn, "click", () => {
            const k = btn.dataset.dmSwatch;
            dmRoot.querySelector(`[data-dm-bag-img="${k}"]`) &&
              (dmRoot.querySelectorAll("[data-dm-swatch]").forEach((b) => {
                const sel = b === btn;
                (b.classList.toggle("is-selected", sel),
                  b.setAttribute("aria-pressed", String(sel)));
              }),
              dmRoot.querySelectorAll("[data-dm-bag-img]").forEach((img) => {
                img.classList.toggle("is-show", img.dataset.dmBagImg === k);
              }));
          });
        }));
      const dmSeg = dmRoot.querySelector("[data-dm-seg]");
      if (
        (dmSeg &&
          dmSeg.querySelectorAll("[data-dm-seg-btn]").forEach((btn) => {
            on(btn, "click", () => {
              (btn.dataset.dmSegBtn === "1"
                ? (dmSeg.dataset.side = "")
                : dmSeg.removeAttribute("data-side"),
                dmSeg.querySelectorAll("[data-dm-seg-btn]").forEach((b) => {
                  const sel = b === btn;
                  (b.classList.toggle("is-on", sel),
                    b.setAttribute("aria-pressed", String(sel)));
                }),
                dmRoot.querySelectorAll("[data-dm-dim]").forEach((img) => {
                  const shown = img.dataset.dmDim === btn.dataset.dmSegBtn;
                  (img.classList.toggle("is-show", shown),
                    img.setAttribute("aria-hidden", String(!shown)));
                }));
            });
          }),
        on(window, "keydown", (e) => {
          if (
            e.target &&
            e.target.matches &&
            e.target.matches("input, textarea, select")
          )
            return;
          const current =
            dmRoot.dataset.open === "" ? -1 : Number(dmRoot.dataset.open);
          if (current === -1 || !dmRoot.contains(e.target)) return;
          if (e.key === "Escape") {
            dmSetDetail(-1);
            return;
          }
          if (
            e.target &&
            e.target.closest &&
            e.target.closest("[data-dm-swatch], [data-dm-seg]")
          )
            return;
          const previousKey =
              e.key === "ArrowLeft" ||
              (dmIsHomeDesktop() && e.key === "ArrowUp"),
            nextKey =
              e.key === "ArrowRight" ||
              (dmIsHomeDesktop() && e.key === "ArrowDown");
          (previousKey &&
            current > 0 &&
            (e.preventDefault(), dmSetDetail(current - 1)),
            nextKey &&
              current < dmPills.length - 1 &&
              (e.preventDefault(), dmSetDetail(current + 1)));
        }),
        "IntersectionObserver" in window)
      ) {
        const dmIo = new IntersectionObserver(
          (es) =>
            es.forEach((en) => {
              en.isIntersecting &&
                (dmRoot.classList.add("is-inview"), dmIo.disconnect());
            }),
          { threshold: 0.18 },
        );
        watch(dmIo, dmRoot);
        const dmNavIo = new IntersectionObserver(
          (es) =>
            es.forEach((en) => {
              en.isIntersecting &&
                (dmRoot.classList.add("is-rail-in"), dmNavIo.disconnect());
            }),
          { threshold: 0.35 },
        );
        watch(dmNavIo, dmNav);
      } else
        (dmRoot.classList.add("is-inview"), dmRoot.classList.add("is-rail-in"));
    }
    const wnRoot = document.querySelector("[data-wn]");
    if (wnRoot) {
      const wnBar = wnRoot.querySelector("[data-wn-bar]"),
        wnList = wnRoot.querySelector("[data-wn-list]"),
        wnFly = wnRoot.querySelector("[data-wn-fly]"),
        wnScrim = wnRoot.querySelector("[data-wn-scrim]"),
        wnVeil = wnRoot.querySelector("[data-wn-veil]"),
        wnCards = [...wnRoot.querySelectorAll("[data-wn-card]")],
        wnExplicitTail = wnRoot.querySelector("[data-wn-tail]"),
        wnVisibleTail = () =>
          wnExplicitTail && getComputedStyle(wnExplicitTail).display !== "none"
            ? wnExplicitTail
            : wnCards[wnCards.length - 1],
        wnTitleTail = wnCards.find((card) => card.dataset.slug === "strap"),
        wnDesktopMq = window.matchMedia("(min-width: 1024px)"),
        wnIsHomeDesktop = () =>
          wnRoot.classList.contains("wn--home") && wnDesktopMq.matches,
        wnIsHome = wnRoot.classList.contains("wn--home");
      let wnOpenCard = null,
        wnOpenHomeDesktop = !1,
        wnOwnsScrollLock = !1,
        wnCloseProperty = "width",
        wnCloseArmedAt = 1 / 0,
        wnCloseMinMs = 0,
        wnCloseTarget = null,
        wnCloseT = 0,
        wnCloseRaf = 0,
        wnFocusT = 0,
        wnOpenedAt = -1 / 0;
      if (
        (cleanups.push(() => {
          (clearTimeout(wnCloseT),
            clearTimeout(wnFocusT),
            wnCloseRaf && cancelAnimationFrame(wnCloseRaf));
        }),
        wnRoot.classList.add("js-armed"),
        "IntersectionObserver" in window)
      ) {
        const io = new IntersectionObserver(
          (es) =>
            es.forEach((en) => {
              en.isIntersecting &&
                (wnRoot.classList.add("is-inview"), io.disconnect());
            }),
          { threshold: 0.08, rootMargin: "0px 0px -8% 0px" },
        );
        watch(io, wnList);
      } else wnRoot.classList.add("is-inview");
      let wnFrame = 0;
      const wnUpdate = () => {
          wnFrame = 0;
          const rect = wnRoot.getBoundingClientRect(),
            stuck = rect.top <= -24 && rect.bottom > 180;
          wnBar.classList.toggle("is-stuck", stuck);
          const pastStrap =
            wnIsHome &&
            !!wnTitleTail &&
            wnTitleTail.getBoundingClientRect().bottom <=
              wnBar.getBoundingClientRect().bottom;
          (wnBar.classList.toggle("is-past-strap", pastStrap),
            wnBar.toggleAttribute("inert", pastStrap),
            pastStrap
              ? (wnBar.setAttribute("aria-hidden", "true"),
                wnBar.contains(document.activeElement) &&
                  document.activeElement.blur())
              : wnBar.removeAttribute("aria-hidden"),
            document.documentElement.toggleAttribute(
              "data-wn-stuck",
              stuck && !pastStrap,
            ));
          const inDockRange =
              rect.top < innerHeight * 0.74 && rect.bottom > innerHeight * 0.18,
            veilTop = wnVeil.getBoundingClientRect().top,
            wnTail = wnVisibleTail();
          wnVeil.classList.toggle(
            "is-on",
            inDockRange &&
              !!wnTail &&
              wnTail.getBoundingClientRect().bottom > veilTop,
          );
        },
        wnQueue = () => {
          wnFrame || (wnFrame = requestAnimationFrame(wnUpdate));
        };
      (wnUpdate(),
        on(window, "scroll", wnQueue, { passive: !0 }),
        on(window, "resize", wnQueue, { passive: !0 }),
        cleanups.push(() => {
          (wnFrame && cancelAnimationFrame(wnFrame),
            wnBar.classList.remove("is-past-strap"),
            wnBar.removeAttribute("inert"),
            wnBar.removeAttribute("aria-hidden"),
            document.documentElement.removeAttribute("data-wn-stuck"));
        }),
        wnRoot.querySelectorAll("[data-wn-cw]").forEach((btn) => {
          on(btn, "click", () => {
            const cw = btn.dataset.wnCw;
            wnRoot.dataset.colorway !== cw &&
              ((wnRoot.dataset.colorway = cw),
              wnRoot.querySelectorAll("[data-wn-cw]").forEach((b) => {
                const sel = b === btn;
                (b.classList.toggle("is-on", sel),
                  b.setAttribute("aria-pressed", String(sel)));
              }));
          });
        }));
      const wnRect = (el, sectionLocal = wnOpenHomeDesktop) => {
          const r = el.getBoundingClientRect();
          if (sectionLocal) {
            const rootRect = wnRoot.getBoundingClientRect();
            return {
              left: r.left - rootRect.left,
              top: r.top - rootRect.top,
              width: r.width,
              height: r.height,
            };
          }
          return { left: r.left, top: r.top, width: r.width, height: r.height };
        },
        wnSetRect = (el, r) => {
          ((el.style.left = `${r.left}px`),
            (el.style.top = `${r.top}px`),
            (el.style.width = `${r.width}px`),
            (el.style.height = `${r.height}px`));
        };
      let wnClosingCard = null;
      const wnFinishClose = (withFocus) => {
          (clearTimeout(wnCloseT),
            (wnCloseT = 0),
            wnCloseRaf && cancelAnimationFrame(wnCloseRaf),
            (wnCloseRaf = 0),
            (wnCloseArmedAt = 1 / 0),
            (wnCloseTarget = null));
          const card = wnClosingCard;
          if (
            ((wnClosingCard = null),
            (wnFly.hidden = !0),
            wnFly.classList.remove("is-closing"),
            (wnFly.innerHTML = ""),
            card &&
              ((card.style.visibility = ""),
              card.removeAttribute("data-wn-source-hidden"),
              card.removeAttribute("aria-hidden"),
              card.removeAttribute("inert")),
            wnOwnsScrollLock && ((wnOwnsScrollLock = !1), unlockScroll()),
            (wnOpenHomeDesktop = !1),
            withFocus && card)
          ) {
            const hit = card.querySelector("[data-wn-open]");
            if (hit) {
              hit.focus({ preventScroll: !0 });
              if (document.activeElement !== hit) {
                clearTimeout(wnFocusT);
                wnFocusT = setTimeout(() => {
                  wnFocusT = 0;
                  const active = document.activeElement;
                  if (!wnOpenCard && !wnClosingCard && hit.isConnected &&
                      (active === document.body || active === document.documentElement)) {
                    hit.focus({ preventScroll: !0 });
                  }
                }, 40);
              }
            }
          }
        },
        wnClose = (instant = !1) => {
          const card = wnOpenCard;
          if (!card || wnFly.hidden) return;
          const current = wnRect(wnFly),
            origin = wnRect(card);
          ((wnCloseTarget = origin), (wnCloseArmedAt = 1 / 0));
          const springRaw = getComputedStyle(wnRoot)
              .getPropertyValue("--wn-spring-t")
              .trim(),
            springValue = parseFloat(springRaw),
            springMs = Number.isFinite(springValue)
              ? springRaw.endsWith("ms")
                ? springValue
                : springValue * 1e3
              : 304;
          ((wnCloseMinMs = reduced ? 0 : springMs * 0.72),
            (wnCloseProperty =
              ["width", "height", "left", "top"].find(
                (prop) => Math.abs(current[prop] - origin[prop]) > 1,
              ) || "width"),
            (wnOpenCard = null),
            (wnClosingCard = card),
            clearTimeout(wnFocusT),
            wnRoot.classList.remove("is-open"),
            wnFly.classList.remove("is-open"),
            wnFly.classList.add("is-closing"));
          const hit = card.querySelector("[data-wn-open]");
          if ((hit && hit.setAttribute("aria-expanded", "false"), instant)) {
            wnFinishClose(!0);
            return;
          }
          ((wnFly.style.transition = "none"),
            wnSetRect(wnFly, current),
            wnFly.offsetWidth,
            wnFly.style.removeProperty("transition"),
            wnFly.offsetWidth,
            (wnCloseRaf = requestAnimationFrame(() => {
              ((wnCloseRaf = 0),
                !(wnClosingCard !== card || wnFly.hidden) &&
                  ((wnCloseArmedAt = performance.now()),
                  wnSetRect(wnFly, origin)));
            })),
            clearTimeout(wnCloseT),
            (wnCloseT = setTimeout(() => wnFinishClose(!0), 800)));
        };
      (on(wnFly, "transitionend", (e) => {
        if (
          !wnClosingCard ||
          e.target !== wnFly ||
          e.propertyName !== wnCloseProperty ||
          !Number.isFinite(wnCloseArmedAt) ||
          performance.now() - wnCloseArmedAt < wnCloseMinMs ||
          !wnCloseTarget
        )
          return;
        const rendered = wnRect(wnFly);
        Math.abs(rendered[wnCloseProperty] - wnCloseTarget[wnCloseProperty]) >
          1.5 || wnFinishClose(!0);
      }),
        cleanups.push(() => {
          (wnOpenCard && ((wnClosingCard = wnOpenCard), (wnOpenCard = null)),
            wnClosingCard && wnFinishClose(!0),
            clearTimeout(wnFocusT),
            wnRoot.classList.remove("is-open"));
        }));
      const wnOpen = (card) => {
        if (wnOpenCard === card) {
          wnClose();
          return;
        }
        if (wnOpenCard) return;
        (wnClosingCard && wnFinishClose(!1),
          (wnOpenCard = card),
          (wnOpenHomeDesktop = wnIsHomeDesktop()),
          (wnOpenedAt = performance.now()),
          (wnFly.innerHTML = ""),
          (wnFly.className = "wn__fly"),
          wnFly.style.removeProperty("--wn-safety-h"));
        const kind = [...card.classList].find((c) =>
          /^wn__card--(item|info|app)$/.test(c),
        );
        kind && wnFly.classList.add(kind.replace("wn__card--", "wn__fly--"));
        const slug = card.dataset.slug;
        (slug && wnFly.classList.add(`wn__fly--${slug}`),
          [...card.children].forEach((n) =>
            wnFly.appendChild(n.cloneNode(!0)),
          ));
        const flyExp = wnFly.querySelector("[data-wn-exp]");
        flyExp &&
          (flyExp.removeAttribute("aria-hidden"),
          flyExp.removeAttribute("inert"));
        const labelEl = card.querySelector(".wn__label"),
          labelSpans = labelEl ? [...labelEl.querySelectorAll("span")] : [],
          label = labelSpans.length
            ? labelSpans.map((s) => s.textContent.trim()).join(" ")
            : (labelEl || {}).textContent || "";
        wnFly.setAttribute("aria-label", label);
        const flyHit = wnFly.querySelector("[data-wn-open]");
        flyHit &&
          (flyHit.setAttribute("aria-expanded", "true"),
          flyHit.setAttribute("aria-label", `Close \u2014 ${label}`));
        const wnDesktop = wnDesktopMq.matches,
          gutter = wnDesktop ? 40 : innerWidth <= 370 ? 12 : 20,
          isApp = card.classList.contains("wn__card--app"),
          W = wnOpenHomeDesktop
            ? Math.min(586, wnRoot.clientWidth - gutter * 2)
            : Math.min(wnDesktop ? 540 : 362, innerWidth - gutter * 2);
        let H = wnOpenHomeDesktop
          ? isApp
            ? 485
            : 445
          : isApp
            ? wnDesktop
              ? 540
              : 380
            : wnDesktop
              ? 420
              : 280;
        const tagList = wnFly.querySelector(".wn__tags");
        if (tagList) {
          const n = tagList.children.length;
          n > 0 &&
            (H = Math.max(
              H,
              wnDesktop
                ? 190 + n * 31 + (n - 1) * 7 + 30
                : 152 + n * 27 + (n - 1) * 6 + 24,
            ));
        }
        const origin = wnRect(card);
        if (isApp) {
          ((wnFly.hidden = !1),
            (wnFly.style.transition = "none"),
            (wnFly.style.visibility = "hidden"),
            wnSetRect(wnFly, {
              left: origin.left,
              top: origin.top,
              width: W,
              height: H,
            }),
            wnFly.offsetWidth);
          const feats = wnFly.querySelector(".wn__features"),
            dl = wnFly.querySelector(".wn__download");
          if (feats && dl) {
            const need = Math.ceil(
              feats.getBoundingClientRect().bottom -
                (dl.getBoundingClientRect().top - 10),
            );
            need > 0 &&
              (wnFly.style.setProperty("--wn-safety-h", `${275 + need}px`),
              (H += need));
          }
        }
        let targetTop, targetLeft;
        if (wnOpenHomeDesktop) {
          const rootRect = wnRoot.getBoundingClientRect(),
            listRect = wnList.getBoundingClientRect();
          ((targetTop =
            listRect.top - rootRect.top + (listRect.height - H) / 2),
            (targetLeft = (wnRoot.clientWidth - W) / 2));
        } else
          ((H = Math.min(H, innerHeight - (wnDesktop ? 80 : 40))),
            (targetTop = Math.max(wnDesktop ? 40 : 20, (innerHeight - H) / 2)),
            (targetLeft = (innerWidth - W) / 2));
        (wnOpenHomeDesktop || (lockScroll(), (wnOwnsScrollLock = !0)),
          (wnFly.hidden = !1),
          (wnFly.style.visibility = ""),
          (wnFly.style.transition = "none"),
          wnSetRect(wnFly, origin),
          wnFly.offsetWidth,
          wnFly.style.removeProperty("transition"),
          (card.style.visibility = "hidden"),
          card.setAttribute("data-wn-source-hidden", ""),
          card.setAttribute("aria-hidden", "true"),
          card.setAttribute("inert", ""),
          wnRoot.classList.add("is-open"),
          requestAnimationFrame(() => {
            wnOpenCard !== card ||
              wnFly.hidden ||
              (wnFly.classList.add("is-open"),
              wnSetRect(wnFly, {
                left: targetLeft,
                top: targetTop,
                width: W,
                height: H,
              }));
          }));
        const hit = card.querySelector("[data-wn-open]");
        (hit && hit.setAttribute("aria-expanded", "true"),
          (flyHit || wnFly).focus({ preventScroll: !0 }),
          clearTimeout(wnFocusT),
          (wnFocusT = setTimeout(
            () => (flyHit || wnFly).focus({ preventScroll: !0 }),
            160,
          )));
      };
      (wnCards.forEach((card) => {
        const hit = card.querySelector("[data-wn-open]");
        hit && on(hit, "click", () => wnOpen(card));
      }),
        on(wnFly, "click", (e) => {
          e.target.closest("a") ||
            (wnIsHome && performance.now() - wnOpenedAt < 450) ||
            wnClose();
        }),
        on(wnScrim, "click", () => wnClose()),
        on(
          window,
          "keydown",
          (e) => {
            if (!wnOpenCard) return;
            const focusedDock =
              e.target && e.target.closest && e.target.closest("nex-gdab");
            if (
              focusedDock &&
              focusedDock.getAttribute("data-gdab-state") !== "pill"
            )
              return;
            if (e.key === "Escape") {
              (e.stopPropagation(), wnClose());
              return;
            }
            if (e.key !== "Tab") return;
            const focusables = [
                ...wnFly.querySelectorAll(
                  'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
                ),
              ].filter((el) => el.offsetParent !== null || el === wnFly),
              dockFocusables = [
                ...document.querySelectorAll(
                  "nex-gdab .gdab__pill, nex-gdab [data-nexie]",
                ),
              ].filter((el) => !el.disabled && el.offsetParent !== null),
              ring = [...focusables, ...dockFocusables];
            if (!ring.length) return;
            const active = document.activeElement,
              at = ring.indexOf(active),
              next =
                at < 0
                  ? e.shiftKey
                    ? ring[ring.length - 1]
                    : ring[0]
                  : ring[
                      (at + (e.shiftKey ? -1 : 1) + ring.length) % ring.length
                    ];
            (e.preventDefault(), next.focus());
          },
          !0,
        ),
        on(
          window,
          "resize",
          () => {
            wnOpenCard &&
              ((wnIsHome && wnOpenHomeDesktop === wnIsHomeDesktop()) ||
                wnClose(wnOpenHomeDesktop !== wnIsHomeDesktop()));
          },
          { passive: !0 },
        ));
    }
    const f3Roots = [...document.querySelectorAll("[data-f3]")];
    (f3Roots.length &&
      f3Roots.forEach((root) => {
        const faqInitialAnswers = [];
        root.querySelectorAll("[data-f3-faq]").forEach((btn) => {
          const ans = document.getElementById(
            btn.getAttribute("aria-controls"),
          );
          if (ans && !btn.hasAttribute("data-faq-ready")) {
            ans.style.transition = "none";
            btn.setAttribute("data-faq-ready", "");
            btn.setAttribute("aria-expanded", "false");
            ans.classList.remove("is-open");
            ans.setAttribute("aria-hidden", "true");
            faqInitialAnswers.push(ans);
          }
          ans &&
            on(btn, "click", () => {
              const open = btn.getAttribute("aria-expanded") === "true";
              (btn.setAttribute("aria-expanded", String(!open)),
                ans.classList.toggle("is-open", !open),
                ans.setAttribute("aria-hidden", String(open)));
            });
        });
        if (faqInitialAnswers.length) {
          void root.offsetHeight;
          faqInitialAnswers.forEach((ans) => ans.style.removeProperty("transition"));
        }
        const faqPanel = root.querySelector("[data-faq-panel]"),
          faqToggle = root.querySelector("[data-faq-toggle]"),
          faqLabel = faqToggle?.querySelector("[data-faq-toggle-label]"),
          faqPreview = root.querySelector("[data-faq-preview]");
        if (faqPanel && faqToggle && faqLabel && faqPreview) {
          const faqItems = [...faqPanel.querySelectorAll(".faq-item")],
            faqEnd = faqItems.findIndex((item) =>
              item.hasAttribute("data-faq-collapse-end"),
            ),
            faqExtra = faqEnd >= 0 ? faqItems.slice(faqEnd + 1) : [],
            faqMobile = matchMedia("(max-width: 1023.98px)"),
            faqReduced = matchMedia("(prefers-reduced-motion: reduce)");
          if (faqExtra.length) {
            let faqExpanded = root.dataset.faqExpanded === "true",
              faqAnimation = null,
              faqFrame = 0,
              faqAnchor = null,
              faqAllowScroll = true;
            faqPreview.textContent = faqExtra[0].querySelector("[data-f3-faq] > span")?.textContent || "";
            const faqStop = () => {
              cancelAnimationFrame(faqFrame);
              faqFrame = 0;
              faqAnchor = null;
              if (faqAnimation) {
                faqAnimation.onfinish = null;
                faqAnimation.cancel();
                faqAnimation = null;
              }
              faqPanel.removeAttribute("data-faq-animating");
              root.removeAttribute("data-faq-animating");
            };
            const faqSync = () => {
              const collapsed = faqMobile.matches && !faqExpanded,
                moveFocus = collapsed && faqExtra.some((item) =>
                  item.contains(document.activeElement),
                );
              if (faqMobile.matches) faqToggle.hidden = false;
              if (moveFocus) faqToggle.focus({ preventScroll: true });
              else if (!faqMobile.matches && document.activeElement === faqToggle)
                faqItems[faqEnd].querySelector("[data-f3-faq]")?.focus({ preventScroll: true });
              faqToggle.hidden = !faqMobile.matches;
              faqExtra.forEach((item) => {
                item.hidden = collapsed;
                item.inert = collapsed;
                if (collapsed) item.setAttribute("aria-hidden", "true");
                else item.removeAttribute("aria-hidden");
              });
              faqPreview.hidden = !collapsed;
              root.toggleAttribute("data-faq-collapsed", collapsed);
              faqToggle.setAttribute("aria-expanded", String(!collapsed));
              faqLabel.textContent = faqExpanded
                ? faqToggle.dataset.labelCollapse
                : faqToggle.dataset.labelExpand;
              return moveFocus;
            };
            const faqSettle = (keepControl = false) => {
              const anchor = keepControl ? faqAnchor : null;
              const movedFocus = faqSync();
              faqStop();
              if (anchor !== null)
                window.scrollTo({ top: scrollY + faqToggle.getBoundingClientRect().top - anchor, behavior: "instant" });
              if ((keepControl || movedFocus) && faqMobile.matches && !faqExpanded) {
                const control = faqToggle.getBoundingClientRect(),
                  viewport = window.visualViewport,
                  visibleTop = viewport?.offsetTop || 0,
                  visibleBottom = Math.min(innerHeight, visibleTop + (viewport?.height || innerHeight)),
                  headerBottom = document.querySelector(".site-header")?.getBoundingClientRect().bottom || 0,
                  marginTop = parseFloat(getComputedStyle(faqToggle).scrollMarginTop) || 0;
                if (control.top < Math.max(visibleTop, headerBottom + 8, marginTop) - 1 ||
                    control.bottom > visibleBottom + 1)
                  faqToggle.scrollIntoView({ block: "nearest", behavior: "instant" });
              }
            };
            const faqChange = (expanded, animate = false) => {
              const from = faqPanel.getBoundingClientRect().height,
                control = faqToggle.getBoundingClientRect();
              faqStop();
              faqAllowScroll = true;
              if (animate && faqMobile.matches && !faqReduced.matches) root.setAttribute("data-faq-animating", "");
              faqExpanded = expanded;
              root.dataset.faqExpanded = String(expanded);
              faqSync();
              const to = faqPanel.getBoundingClientRect().height;
              if (!animate || !faqMobile.matches || faqReduced.matches ||
                  !faqPanel.animate || Math.abs(from - to) < 1) {
                faqSettle(!expanded);
                return;
              }
              if (!expanded) {
                faqExtra.forEach((item) => { item.hidden = false; });
                faqPreview.hidden = true;
              }
              faqExtra.forEach((item) => {
                item.inert = true;
                item.setAttribute("aria-hidden", "true");
              });
              faqPanel.setAttribute("data-faq-animating", "");
              faqAnimation = faqPanel.animate(
                [{ height: `${from}px` }, { height: `${to}px` }],
                { duration: 260, easing: "cubic-bezier(.22, .61, .36, 1)", fill: "both" },
              );
              if (!expanded && control.top >= 0 && control.bottom <= innerHeight) {
                const header = document.querySelector(".site-header");
                faqAnchor = Math.max(control.top, (header?.getBoundingClientRect().bottom || 0) + 16);
                const followControl = () => {
                  if (!faqAnimation || faqAnchor === null) return;
                  const delta = faqToggle.getBoundingClientRect().top - faqAnchor;
                  if (Math.abs(delta) > 0.5) window.scrollTo({ top: scrollY + delta, behavior: "instant" });
                  faqFrame = requestAnimationFrame(followControl);
                };
                followControl();
              }
              faqAnimation.onfinish = () => faqSettle(!expanded && faqAllowScroll);
            };
            on(faqToggle, "click", () => faqChange(!faqExpanded, true));
            onMq(faqMobile, () => faqSettle());
            onMq(faqReduced, () => faqSettle(!faqExpanded && faqAllowScroll));
            on(window, "pagehide", () => faqSettle());
            const faqReleaseScroll = () => { faqAnchor = null; faqAllowScroll = false; };
            on(window, "wheel", faqReleaseScroll, { passive: true });
            on(window, "touchmove", faqReleaseScroll, { passive: true });
            on(window, "keydown", (event) => {
              if (["Tab", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(event.key) ||
                  (event.key === " " && event.target !== faqToggle)) faqReleaseScroll();
            });
            on(window, "resize", () => {
              if (faqAnimation) faqSettle(!faqExpanded && faqAllowScroll);
            }, { passive: true });
            on(faqPanel, "click", () => {
              if (faqAnimation) faqSettle();
            });
            const faqRevealHash = () => {
              let target;
              try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); }
              catch { return; }
              if (!target || !faqItems.some((item) => item.contains(target))) return;
              const extraTarget = faqMobile.matches && faqExtra.some((item) => item.contains(target)),
                needsReveal = extraTarget && (!faqExpanded || !!faqAnimation),
                answer = target.closest(".faq-answer");
              if (answer) {
                root.dataset.faqExpanded = String(faqExpanded);
                answer.classList.add("is-open");
                answer.setAttribute("aria-hidden", "false");
                document.getElementById(answer.getAttribute("aria-labelledby"))?.setAttribute("aria-expanded", "true");
              }
              if (extraTarget) faqChange(true);
              else if (faqAnimation) faqSettle();
              if (needsReveal || answer) target.scrollIntoView({ block: "start", behavior: "instant" });
            };
            on(window, "hashchange", faqRevealHash);
            on(root, "shopify:block:select", (event) => {
              if (faqExtra.some((item) => item.contains(event.target))) faqChange(true);
            });
            cleanups.push(() => {
              faqStop();
              faqExtra.forEach((item) => {
                item.hidden = false;
                item.inert = false;
                item.removeAttribute("aria-hidden");
              });
              faqPreview.hidden = true;
              faqToggle.hidden = true;
              root.removeAttribute("data-faq-collapsed");
            });
            faqSync();
            faqRevealHash();
          }
        }
        const back = root.querySelector("[data-f3-modal]");
        if (!back) return;
        const mEyebrow = back.querySelector("[data-f3-m-eyebrow]"),
          mTitle = back.querySelector("[data-f3-m-title]"),
          mBody = back.querySelector("[data-f3-m-body]"),
          mClose = back.querySelector("[data-f3-modal-close]"),
          mDialog = back.querySelector(".detail-modal");
        let f3Opener = null,
          f3ClosingT = null;
        const f3IsOpen = () =>
            !back.hidden && !back.classList.contains("is-closing"),
          f3Close = () => {
            f3IsOpen() &&
              (back.classList.add("is-closing"),
              (f3ClosingT = setTimeout(
                () => {
                  ((f3ClosingT = null),
                    (back.hidden = !0),
                    back.classList.remove("is-closing"));
                },
                reduced ? 0 : 210,
              )),
              unlockScroll(),
              f3Opener && (f3Opener.focus(), (f3Opener = null)));
          },
          f3Open = (card, opener) => {
            (f3ClosingT && (clearTimeout(f3ClosingT), (f3ClosingT = null)),
              back.classList.remove("is-closing"),
              (mEyebrow.textContent =
                card.getAttribute("data-f3-eyebrow") || ""),
              (mTitle.textContent = card.getAttribute("data-f3-title") || ""),
              (mBody.textContent = card.getAttribute("data-f3-body") || ""),
              mDialog.style.setProperty(
                "--accent",
                card.getAttribute("data-f3-accent") || "var(--nex-orange)",
              ),
              (f3Opener = opener),
              (back.hidden = !1),
              lockScroll(),
              mClose.focus());
          };
        (root.querySelectorAll("[data-f3-card]").forEach((card) => {
          const opener = card.querySelector("[data-f3-open]");
          opener && on(card, "click", () => f3Open(card, opener));
        }),
          on(mClose, "click", f3Close),
          on(back, "mousedown", (e) => {
            e.target === back && f3Close();
          }),
          on(
            window,
            "keydown",
            (e) => {
              if (!f3IsOpen()) return;
              const focusedDock =
                e.target && e.target.closest && e.target.closest("nex-gdab");
              if (
                focusedDock &&
                focusedDock.getAttribute("data-gdab-state") !== "pill"
              )
                return;
              if (e.key === "Escape") {
                (e.stopPropagation(), f3Close());
                return;
              }
              if (e.key !== "Tab") return;
              const focusables = [
                  ...mDialog.querySelectorAll(
                    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
                  ),
                ].filter((el) => el.offsetParent !== null),
                dockFocusables = [
                  ...document.querySelectorAll(
                    "nex-gdab .gdab__pill, nex-gdab [data-nexie]",
                  ),
                ].filter((el) => !el.disabled && el.offsetParent !== null),
                ring = [...focusables, ...dockFocusables];
              if (!ring.length) return;
              const active = document.activeElement,
                at = ring.indexOf(active),
                next =
                  at < 0
                    ? e.shiftKey
                      ? ring[ring.length - 1]
                      : ring[0]
                    : ring[
                        (at + (e.shiftKey ? -1 : 1) + ring.length) % ring.length
                      ];
              (e.preventDefault(), next.focus());
            },
            !0,
          ),
          cleanups.push(() => {
            f3ClosingT && clearTimeout(f3ClosingT);
            const held = f3IsOpen(),
              opener = f3Opener;
            ((f3Opener = null),
              (back.hidden = !0),
              back.classList.remove("is-closing"),
              held && unlockScroll(),
              opener &&
                opener.isConnected &&
                opener.focus({ preventScroll: !0 }));
          }));
      }),
      document.querySelectorAll("[data-ed]").forEach((edRoot) => {
        const items = [...edRoot.querySelectorAll("[data-ed-item]")],
          edFit = () => {
            const w = edRoot.clientWidth;
            if (!w) return;
            if (innerWidth >= 1024) {
              if (edRoot.classList.contains("ed--home")) {
                const s2 = Math.min(Math.max(w / 890, 1.15), 1.6);
                (edRoot.style.setProperty("--ed-s", s2),
                  edRoot.style.setProperty(
                    "--ed-x",
                    `${Math.max(0, (w - 402 * s2) / 2)}px`,
                  ));
                return;
              }
              (edRoot.style.setProperty("--ed-s", 1),
                edRoot.style.setProperty("--ed-x", "0px"));
              return;
            }
            const s = Math.min(w / 402, window.matchMedia("(min-width: 600px)").matches ? 1.6 : 1.15);
            (edRoot.style.setProperty("--ed-s", s),
              edRoot.style.setProperty(
                "--ed-x",
                `${Math.max(0, (w - 402 * s) / 2)}px`,
              ));
          };
        if (
          (edFit(),
          "ResizeObserver" in window
            ? watch(new ResizeObserver(edFit), edRoot)
            : on(window, "resize", edFit, { passive: !0 }),
          !items.length)
        )
          return;
        if (reduced || !("IntersectionObserver" in window)) {
          items.forEach((el) => el.classList.add("is-edin"));
          return;
        }
        const seen = new Array(items.length).fill(!1);
        let flushT = null;
        const flush = () => {
            flushT = null;
            for (let i = 0; i < items.length; i += 1)
              if (seen[i] && !items[i].classList.contains("is-edin")) {
                (items[i].classList.add("is-edin"),
                  (flushT = setTimeout(flush, 130)));
                return;
              }
          },
          io = new IntersectionObserver(
            (entries) => {
              (entries.forEach((en) => {
                const i = items.indexOf(en.target);
                if (en.isIntersecting)
                  for (let k = 0; k <= i; k += 1) seen[k] = !0;
                else ((seen[i] = !1), items[i].classList.remove("is-edin"));
              }),
                flushT || flush());
            },
            { threshold: 0.5, rootMargin: "0px 0px -6% 0px" },
          );
        (items.forEach((el) => io.observe(el)),
          off.push(() => io.disconnect()),
          cleanups.push(() => {
            flushT && clearTimeout(flushT);
          }));
      }),
      document.documentElement.setAttribute("data-rise", "on"));
    const risers = document.querySelectorAll(".io-rise");
    if (risers.length && "IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (es) =>
          es.forEach((e) => {
            e.isIntersecting &&
              (e.target.classList.add("is-in"), io.unobserve(e.target));
          }),
        { rootMargin: "0px 0px -8% 0px" },
      );
      (risers.forEach((r) => io.observe(r)), off.push(() => io.disconnect()));
    } else risers.forEach((r) => r.classList.add("is-in"));
    const wildRow = document.querySelector("[data-wild-row]");
    if (wildRow) {
      let wArmWarmObserver = function () {
        if (wPrewarmOn || !("IntersectionObserver" in window)) return;
        wWarmIo && wWarmIo.disconnect();
        const lead = Math.max(
          1,
          Math.ceil(
            window.innerHeight || document.documentElement.clientHeight,
          ),
        );
        ((wWarmIo = new IntersectionObserver(
          (entries) =>
            entries.forEach((entry) => {
              entry.isIntersecting &&
                ((wPrewarmOn = !0),
                wWarmWindow(wActive),
                wWarmIo.disconnect(),
                (wWarmIo = null));
            }),
          { rootMargin: `${lead}px 0px` },
        )),
          wWarmIo.observe(wildRow));
      };
      const wCards = Array.from(wildRow.querySelectorAll("[data-wild-card]")),
        wVideos = wCards.map((card) => card.querySelector("video"));
      let wPend = 0,
        wActive = 0,
        wPrewarmOn = !1,
        wPad = parseFloat(getComputedStyle(wildRow).paddingLeft) || 20,
        wGap = parseFloat(getComputedStyle(wildRow).columnGap) || 24.2,
        wWarmIo = null,
        wWarmRearm = 0,
        wWarmFallback = null;
      const wIsConstrained = () => {
          const connection =
            navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;
          return (
            reduced ||
            !!(
              connection &&
              (connection.saveData ||
                /^(slow-2g|2g)$/.test(connection.effectiveType || ""))
            )
          );
        },
        wWarmVideo = (index) => {
          const video = wVideos[index];
          if (!video) return;
          const target = wIsConstrained() ? "metadata" : "auto";
          if (
            video.dataset.wildPreload === "auto" ||
            video.dataset.wildPreload === target
          )
            return;
          const shouldLoad =
            video.paused && video.readyState === 0 && video.networkState !== 2;
          ((video.preload = target),
            (video.dataset.wildPreload = target),
            shouldLoad && video.load());
        },
        wWarmWindow = (index) => {
          wPrewarmOn &&
            (wWarmVideo(index),
            wIsConstrained() || (wWarmVideo(index - 1), wWarmVideo(index + 1)));
        };
      let wildOn = !1;
      const wSync = () => {
          wPend = 0;
          let best = wActive,
            bestBloom = -1;
          (wCards.forEach((c, index) => {
            const d = Math.abs(c.offsetLeft - wPad - wildRow.scrollLeft),
              b = Math.max(0, 1 - d / (c.offsetWidth * 0.9));
            (c.style.setProperty("--wb", b.toFixed(3)),
              b > bestBloom && ((bestBloom = b), (best = index)));
            const v = c.querySelector("video");
            v &&
              (b > 0.6
                ? wildOn && !reduced && v.paused && v.play().catch(() => {})
                : v.paused || v.pause());
          }),
            best !== wActive && ((wActive = best), wWarmWindow(wActive)));
          const max = wildRow.scrollWidth - wildRow.clientWidth;
          (wPrevBtn &&
            wPrevBtn.toggleAttribute("data-edge", wildRow.scrollLeft < 8),
            wNextBtn &&
              wNextBtn.toggleAttribute(
                "data-edge",
                wildRow.scrollLeft > max - 8,
              ));
        },
        wPrevBtn = document.querySelector("[data-wild-prev]"),
        wNextBtn = document.querySelector("[data-wild-next]");
      (wildRow.querySelectorAll("video").forEach((v) => {
        // Reduced motion disables autoplay; keep deliberate playback available.
        if (reduced) {
          v.controls = true;
          const card = v.closest("[data-wild-card]"),
            poster = card?.querySelector(".wild__poster"),
            sound = card?.querySelector("[data-wild-sound]");
          if (poster) {
            const syncPoster = () => {
              if (poster.naturalWidth > 1) v.poster = poster.currentSrc || poster.src;
            };
            on(poster, "load", syncPoster);
            syncPoster();
            poster.style.visibility = "hidden";
          }
          if (sound) sound.style.display = "none";
        }
        on(v, "playing", () => {
          const card = v.closest("[data-wild-card]");
          card && card.classList.add("is-live");
        });
      }),
        wildRow.querySelectorAll("[data-wild-sound]").forEach((btn) => {
          on(btn, "click", (e) => {
            e.stopPropagation();
            const v = btn.closest("[data-wild-card]").querySelector("video");
            v && carouselSound.togglePreservingPlayback(v);
          });
        }),
        on(
          wildRow,
          "scroll",
          () => {
            wPend || (wPend = requestAnimationFrame(wSync));
          },
          { passive: !0 },
        ),
        on(
          window,
          "resize",
          () => {
            ((wPad = parseFloat(getComputedStyle(wildRow).paddingLeft) || 20),
              (wGap = parseFloat(getComputedStyle(wildRow).columnGap) || 24.2),
              wPend || (wPend = requestAnimationFrame(wSync)),
              wWarmFallback
                ? wWarmFallback()
                : !wPrewarmOn &&
                  !wWarmRearm &&
                  (wWarmRearm = requestAnimationFrame(() => {
                    ((wWarmRearm = 0), wArmWarmObserver());
                  })));
          },
          { passive: !0 },
        ),
        requestAnimationFrame(() => {
          dead || wSync();
        }),
        cleanups.push(() => cancelAnimationFrame(wPend)));
      const wStep = (dir) =>
        wildRow.scrollBy({
          left: dir * (wCards[0] ? wCards[0].offsetWidth + wGap : 290),
          behavior: "smooth",
        });
      if (
        (wPrevBtn && on(wPrevBtn, "click", () => wStep(-1)),
        wNextBtn && on(wNextBtn, "click", () => wStep(1)),
        "IntersectionObserver" in window)
      ) {
        wArmWarmObserver();
        const wio = new IntersectionObserver(
          (es) =>
            es.forEach((en) => {
              en.isIntersecting
                ? ((wildOn = !0), wSync())
                : ((wildOn = !1),
                  wCards.forEach((c) => {
                    const v = c.querySelector("video");
                    v && !v.paused && v.pause();
                  }));
            }),
          { rootMargin: "80px" },
        );
        watch(wio, wildRow);
      } else
        ((wWarmFallback = () => {
          const lead = Math.max(
              1,
              window.innerHeight || document.documentElement.clientHeight,
            ),
            rect = wildRow.getBoundingClientRect();
          rect.top <= lead * 2 &&
            rect.bottom >= -lead &&
            !wPrewarmOn &&
            ((wPrewarmOn = !0), wWarmWindow(wActive));
          const playNear = rect.top <= lead + 80 && rect.bottom >= -80;
          playNear !== wildOn &&
            ((wildOn = playNear),
            wildOn
              ? wPend || (wPend = requestAnimationFrame(wSync))
              : wVideos.forEach((video) => {
                  video && !video.paused && video.pause();
                }));
        }),
          on(window, "scroll", wWarmFallback, { passive: !0 }),
          requestAnimationFrame(() => {
            dead || wWarmFallback();
          }));
      cleanups.push(() => {
        (wWarmIo && wWarmIo.disconnect(),
          wWarmRearm && cancelAnimationFrame(wWarmRearm));
      });
    }
    const nexBtn = document.querySelector("[data-nexie]");
    if (((nexBtnRef = nexBtn), nexBtn)) {
      const NEX_SRC =
          nexBtn.getAttribute("data-nexie-src") ||
          "https://nex-platform-support-chat.pages.dev/nex-support.js",
        nexReadyWaiters = new Set(),
        clearNexReady = () => {
          (nexReadyWaiters.forEach((handler) =>
            removeEventListener("nex-support:ready", handler),
          ),
            nexReadyWaiters.clear());
        };
      cleanups.push(clearNexReady);
      const nexInject = () => {
          if (nexInjected) return;
          ((nexInjected = !0),
            nexBtnRef && nexBtnRef.removeAttribute("data-chat-error"));
          const s = document.createElement("script");
          ((s.src = NEX_SRC),
            (s.defer = !0),
            s.setAttribute("data-headless", ""),
            s.setAttribute("data-z-index", "150"),
            s.setAttribute("data-no-fonts", ""),
            (s.onerror = () => {
              ((nexInjected = !1),
                clearNexReady(),
                s.remove(),
                nexBtnRef && nexBtnRef.setAttribute("data-chat-error", ""),
                dispatchEvent(new CustomEvent("nex-support:error")));
            }),
            document.head.appendChild(s));
        },
        nexReady = (cb) => {
          if (window.NexSupport) cb();
          else {
            const handler = () => {
              (nexReadyWaiters.delete(handler), cb());
            };
            (nexReadyWaiters.add(handler),
              addEventListener("nex-support:ready", handler, { once: !0 }));
          }
        },
        nexWire = () =>
          nexReady(() => {
            if (nexWired) return;
            nexWired = !0;
            const api = window.NexSupport;
            (api.on("open", () => {
              nexBtnRef && nexBtnRef.setAttribute("data-chat-open", "");
            }),
              api.on("close", () => {
                nexBtnRef && nexBtnRef.removeAttribute("data-chat-open");
              }),
              api.on("unread", (n) => {
                const b =
                  nexBtnRef && nexBtnRef.querySelector("[data-nexie-badge]");
                b &&
                  ((b.hidden = !n), (b.textContent = n > 9 ? "9+" : String(n)));
              }));
          }),
        nexIdleGo = () => {
          (nexInject(), nexWire());
        },
        landerHero = document.querySelector("[data-lp-hero], .hero[data-nex-page-shell=landing]");
      if (
        document.documentElement.getAttribute("data-nex-widget-gate") ===
        "waiting"
      )
        on(document, "nex:highlights-ready", nexIdleGo, { once: !0 });
      else if (landerHero) {
        let nexAfterHero = !1;
        const warmAfterHero = () => {
          nexAfterHero || ((nexAfterHero = !0), nexIdleGo());
        };
        if ("IntersectionObserver" in window) {
          const nexHeroIo = new IntersectionObserver((entries) =>
            entries.forEach((entry) => {
              !entry.isIntersecting &&
                entry.boundingClientRect.bottom <= 0 &&
                warmAfterHero();
            }),
          );
          watch(nexHeroIo, landerHero);
        } else {
          const afterHeroScroll = () => {
            landerHero.getBoundingClientRect().bottom <= 0 && warmAfterHero();
          };
          (on(window, "scroll", afterHeroScroll, { passive: !0 }),
            afterHeroScroll());
        }
      } else if ("requestIdleCallback" in window) {
        const nexIdleId = requestIdleCallback(nexIdleGo, { timeout: 8e3 });
        cleanups.push(() => cancelIdleCallback(nexIdleId));
      } else {
        const nexIdleT = setTimeout(nexIdleGo, 4e3);
        cleanups.push(() => clearTimeout(nexIdleT));
      }
      const nexLabel = nexBtn.getAttribute("aria-label") || "Live chat";
      let nexOpening = !1;
      const nexBusy = (busy, failed = !1) => {
        (nexBtn.toggleAttribute("aria-busy", busy),
          nexBtn.setAttribute(
            "aria-label",
            busy
              ? "Loading live chat"
              : failed
                ? "Live chat unavailable. Activate to retry"
                : nexLabel,
          ));
      };
      (on(window, "nex-support:error", () => {
        ((nexOpening = !1), nexBusy(!1, !0));
      }),
        on(nexBtn, "click", () => {
          nexOpening ||
            ((nexOpening = !0),
            nexBtn.removeAttribute("data-chat-error"),
            nexBusy(!0),
            nexInject(),
            nexReady(() => {
              ((nexOpening = !1),
                nexBusy(!1),
                nexWire(),
                window.NexSupport.toggle());
            }));
        }));
    }
    const headerTrust = header.querySelector("[data-header-trust]"),
      headerTrustCopy =
        headerTrust && headerTrust.querySelector("[data-header-trust-copy]");
    if (headerTrust && headerTrustCopy) {
      let messages = [];
      try {
        messages = JSON.parse(headerTrust.dataset.headerTrust || "[]").filter(
          (message) => typeof message === "string" && message.trim(),
        );
      } catch {}
      if (messages.length) {
        const headerTrustMq = matchMedia("(max-width: 1023.98px)"),
          headerTrustInterval = Math.max(
            2000,
            parseInt(headerTrust.dataset.headerTrustInterval, 10) || 7000,
          );
        let headerTrustIndex = 0,
          headerTrustTimer = 0,
          headerTrustGlowTimer = 0,
          headerTrustRunning = !1;
        const clearHeaderTrustBeat = () => {
            (clearTimeout(headerTrustGlowTimer),
              (headerTrustGlowTimer = 0),
              headerTrustCopy.classList.remove("is-changing"));
          },
          stopHeaderTrust = () => {
            (clearTimeout(headerTrustTimer),
              (headerTrustTimer = 0),
              (headerTrustRunning = !1),
              clearHeaderTrustBeat());
          },
          headerTrustBeat = () => {
            if (reduced) return;
            (clearHeaderTrustBeat(),
              void headerTrustCopy.offsetWidth,
              headerTrustCopy.classList.add("is-changing"),
              (headerTrustGlowTimer = setTimeout(
                clearHeaderTrustBeat,
                2100,
              )));
          },
          scheduleHeaderTrust = () => {
            clearTimeout(headerTrustTimer);
            if (
              !headerTrustRunning ||
              document.visibilityState === "hidden" ||
              messages.length < 2
            )
              return;
            headerTrustTimer = setTimeout(() => {
              headerTrustIndex = (headerTrustIndex + 1) % messages.length;
              headerTrustCopy.textContent = messages[headerTrustIndex];
              headerTrustBeat();
              scheduleHeaderTrust();
            }, headerTrustInterval);
          },
          syncHeaderTrust = (initial = !1) => {
            const shouldRun =
              headerTrustMq.matches &&
              document.visibilityState !== "hidden";
            if (!shouldRun) {
              stopHeaderTrust();
              return;
            }
            if (!headerTrustRunning) {
              headerTrustRunning = !0;
              if (initial) {
                headerTrustIndex = 0;
                headerTrustCopy.textContent = messages[0];
                headerTrustBeat();
              }
            }
            scheduleHeaderTrust();
          };
        (onMq(headerTrustMq, () => syncHeaderTrust(!0)),
          on(document, "visibilitychange", () => syncHeaderTrust(!1)),
          cleanups.push(stopHeaderTrust),
          syncHeaderTrust(!0));
      }
    }

    const cartBtn = header.querySelector("[data-cart-open]");
    cartBtn &&
      on(cartBtn, "click", (event) => {
        const dock = document.querySelector("nex-gdab");
        if (
          !(
            dock &&
            dock.__init &&
            typeof dock.openCartDirect == "function" &&
            !dock.hasAttribute("data-gdab-duplicate")
          )
        ) {
          if (cartBtn.matches("a[href]")) return;
          window.location.href =
            cartBtn.getAttribute("data-cart-url") || "/cart";
          return;
        }
        (event.preventDefault(),
          document.dispatchEvent(new CustomEvent("gdab:open-cart")));
      });
    const digit = header.querySelector("[data-cart-count]"),
      bubble = header.querySelector(".site-header__cart-badge");
    if (digit && bubble) {
      const sync = () => {
          const n =
            parseInt(digit.dataset.tickText || digit.textContent, 10) || 0;
          if (((bubble.hidden = n === 0), cartBtn)) {
            const one = cartBtn.dataset.labelCartOne,
              other = cartBtn.dataset.labelCartOther,
              base = cartBtn.dataset.labelCart || "Cart";
            cartBtn.setAttribute(
              "aria-label",
              n === 0
                ? base
                : n === 1 && one
                  ? one
                  : other
                    ? other.replace("%s", String(n))
                    : base + ", " + n,
            );
          }
          const visual = n > 9 ? "9+" : String(n);
          !digit.classList.contains("gdab__tick") &&
            digit.textContent.trim() !== visual &&
            (digit.textContent = visual);
        },
        mo = new MutationObserver(sync);
      (watch(mo, digit, {
        attributes: !0,
        attributeFilter: ["data-tick-text"],
        childList: !0,
        subtree: !0,
      }),
        sync());
    }
    return (
      cleanups.push(() => {
        lockCount > 0 && ((lockCount = 1), unlockScroll());
      }),
      () => {
        ((dead = !0),
          off.forEach((f) => {
            try {
              f();
            } catch {}
          }),
          (off.length = 0),
          cleanups.forEach((f) => {
            try {
              f();
            } catch {}
          }),
          (cleanups.length = 0),
          document.documentElement.removeAttribute("data-story-snap"),
          document.documentElement.removeAttribute("data-step-snap"));
      }
    );
  };
  storyGuard();
  let dispose = start();
  let rebootT = 0;
  const reboot = () => {
    rebootT ||
      (rebootT = setTimeout(() => {
        ((rebootT = 0), dispose && dispose(), (dispose = start()));
      }, 0));
  };
  (document.addEventListener("shopify:section:load", reboot),
    document.addEventListener("shopify:section:unload", reboot));
  const rmq = window.matchMedia("(prefers-reduced-motion: reduce)");
  rmq.addEventListener
    ? rmq.addEventListener("change", reboot)
    : rmq.addListener && rmq.addListener(reboot);
})();
//# sourceMappingURL=/cdn/shop/t/88/assets/site.js.map?v=128373374265032465211788026118

